import Ae, { createElement as Fe, isValidElement as xt, cloneElement as wr, Children as Aa, Fragment as $a, createContext as xr, useContext as un, useState as Te, useRef as cn, useEffect as we, useCallback as Ge, useReducer as Tr, useMemo as La } from "react";
import { TagCompilationStatus as ue, PackType as Da, apiClient as _a } from "@abtasty/api-client";
import { Title as Ia, Paragraph as ja, Button as ln, ModalV2 as Ma, LoadingIndicatorThreeDots as Sr, Tooltip as Fa, Icon as Tt } from "@abtasty/design-system";
import Se, { css as ye, keyframes as Er } from "styled-components";
import ht from "react-dom";
var $ = /* @__PURE__ */ ((t) => (t[t.idle = 0] = "idle", t[t.inactive = 1] = "inactive", t[t.success = 2] = "success", t[t.empty = 3] = "empty", t[t.api_error = 4] = "api_error", t[t.warning = 5] = "warning", t[t.error = 6] = "error", t[t.pending = 7] = "pending", t[t.user_error = 8] = "user_error", t))($ || {}), Oe = /* @__PURE__ */ ((t) => (t[t.success = 1] = "success", t[t.idle = 0] = "idle", t[t.empty = -1] = "empty", t[t.error = -2] = "error", t))(Oe || {});
function Or(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var pt = { exports: {} }, ze = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var It, Rn;
function fn() {
  if (Rn) return It;
  Rn = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, o = 0; o < 10; o++)
        s["_" + String.fromCharCode(o)] = o;
      var u = Object.getOwnPropertyNames(s).map(function(l) {
        return s[l];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        c[l] = l;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return It = a() ? Object.assign : function(i, s) {
    for (var o, u = r(i), c, l = 1; l < arguments.length; l++) {
      o = Object(arguments[l]);
      for (var h in o)
        e.call(o, h) && (u[h] = o[h]);
      if (t) {
        c = t(o);
        for (var d = 0; d < c.length; d++)
          n.call(o, c[d]) && (u[c[d]] = o[c[d]]);
      }
    }
    return u;
  }, It;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nn;
function Ua() {
  if (Nn) return ze;
  Nn = 1, fn();
  var t = Ae, e = 60103;
  if (ze.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var n = Symbol.for;
    e = n("react.element"), ze.Fragment = n("react.fragment");
  }
  var r = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = Object.prototype.hasOwnProperty, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(o, u, c) {
    var l, h = {}, d = null, m = null;
    c !== void 0 && (d = "" + c), u.key !== void 0 && (d = "" + u.key), u.ref !== void 0 && (m = u.ref);
    for (l in u) a.call(u, l) && !i.hasOwnProperty(l) && (h[l] = u[l]);
    if (o && o.defaultProps) for (l in u = o.defaultProps, u) h[l] === void 0 && (h[l] = u[l]);
    return { $$typeof: e, type: o, key: d, ref: m, props: h, _owner: r.current };
  }
  return ze.jsx = s, ze.jsxs = s, ze;
}
var jt = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var An;
function Wa() {
  return An || (An = 1, function(t) {
    process.env.NODE_ENV !== "production" && function() {
      var e = Ae, n = fn(), r = 60103, a = 60106;
      t.Fragment = 60107;
      var i = 60108, s = 60114, o = 60109, u = 60110, c = 60112, l = 60113, h = 60120, d = 60115, m = 60116, g = 60121, w = 60122, y = 60117, P = 60129, E = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var x = Symbol.for;
        r = x("react.element"), a = x("react.portal"), t.Fragment = x("react.fragment"), i = x("react.strict_mode"), s = x("react.profiler"), o = x("react.provider"), u = x("react.context"), c = x("react.forward_ref"), l = x("react.suspense"), h = x("react.suspense_list"), d = x("react.memo"), m = x("react.lazy"), g = x("react.block"), w = x("react.server.block"), y = x("react.fundamental"), x("react.scope"), x("react.opaque.id"), P = x("react.debug_trace_mode"), x("react.offscreen"), E = x("react.legacy_hidden");
      }
      var T = typeof Symbol == "function" && Symbol.iterator, p = "@@iterator";
      function S(f) {
        if (f === null || typeof f != "object")
          return null;
        var b = T && f[T] || f[p];
        return typeof b == "function" ? b : null;
      }
      var A = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function R(f) {
        {
          for (var b = arguments.length, k = new Array(b > 1 ? b - 1 : 0), L = 1; L < b; L++)
            k[L - 1] = arguments[L];
          V("error", f, k);
        }
      }
      function V(f, b, k) {
        {
          var L = A.ReactDebugCurrentFrame, ae = L.getStackAddendum();
          ae !== "" && (b += "%s", k = k.concat([ae]));
          var ne = k.map(function(G) {
            return "" + G;
          });
          ne.unshift("Warning: " + b), Function.prototype.apply.call(console[f], console, ne);
        }
      }
      var J = !1;
      function q(f) {
        return !!(typeof f == "string" || typeof f == "function" || f === t.Fragment || f === s || f === P || f === i || f === l || f === h || f === E || J || typeof f == "object" && f !== null && (f.$$typeof === m || f.$$typeof === d || f.$$typeof === o || f.$$typeof === u || f.$$typeof === c || f.$$typeof === y || f.$$typeof === g || f[0] === w));
      }
      function ee(f, b, k) {
        var L = b.displayName || b.name || "";
        return f.displayName || (L !== "" ? k + "(" + L + ")" : k);
      }
      function pe(f) {
        return f.displayName || "Context";
      }
      function te(f) {
        if (f == null)
          return null;
        if (typeof f.tag == "number" && R("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof f == "function")
          return f.displayName || f.name || null;
        if (typeof f == "string")
          return f;
        switch (f) {
          case t.Fragment:
            return "Fragment";
          case a:
            return "Portal";
          case s:
            return "Profiler";
          case i:
            return "StrictMode";
          case l:
            return "Suspense";
          case h:
            return "SuspenseList";
        }
        if (typeof f == "object")
          switch (f.$$typeof) {
            case u:
              var b = f;
              return pe(b) + ".Consumer";
            case o:
              var k = f;
              return pe(k._context) + ".Provider";
            case c:
              return ee(f, f.render, "ForwardRef");
            case d:
              return te(f.type);
            case g:
              return te(f._render);
            case m: {
              var L = f, ae = L._payload, ne = L._init;
              try {
                return te(ne(ae));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var oe = 0, ie, K, re, de, v, O, D;
      function j() {
      }
      j.__reactDisabledLog = !0;
      function _() {
        {
          if (oe === 0) {
            ie = console.log, K = console.info, re = console.warn, de = console.error, v = console.group, O = console.groupCollapsed, D = console.groupEnd;
            var f = {
              configurable: !0,
              enumerable: !0,
              value: j,
              writable: !0
            };
            Object.defineProperties(console, {
              info: f,
              log: f,
              warn: f,
              error: f,
              group: f,
              groupCollapsed: f,
              groupEnd: f
            });
          }
          oe++;
        }
      }
      function B() {
        {
          if (oe--, oe === 0) {
            var f = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: n({}, f, {
                value: ie
              }),
              info: n({}, f, {
                value: K
              }),
              warn: n({}, f, {
                value: re
              }),
              error: n({}, f, {
                value: de
              }),
              group: n({}, f, {
                value: v
              }),
              groupCollapsed: n({}, f, {
                value: O
              }),
              groupEnd: n({}, f, {
                value: D
              })
            });
          }
          oe < 0 && R("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var U = A.ReactCurrentDispatcher, M;
      function z(f, b, k) {
        {
          if (M === void 0)
            try {
              throw Error();
            } catch (ae) {
              var L = ae.stack.trim().match(/\n( *(at )?)/);
              M = L && L[1] || "";
            }
          return `
` + M + f;
        }
      }
      var W = !1, Y;
      {
        var he = typeof WeakMap == "function" ? WeakMap : Map;
        Y = new he();
      }
      function C(f, b) {
        if (!f || W)
          return "";
        {
          var k = Y.get(f);
          if (k !== void 0)
            return k;
        }
        var L;
        W = !0;
        var ae = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var ne;
        ne = U.current, U.current = null, _();
        try {
          if (b) {
            var G = function() {
              throw Error();
            };
            if (Object.defineProperty(G.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(G, []);
              } catch (Ne) {
                L = Ne;
              }
              Reflect.construct(f, [], G);
            } else {
              try {
                G.call();
              } catch (Ne) {
                L = Ne;
              }
              f.call(G.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Ne) {
              L = Ne;
            }
            f();
          }
        } catch (Ne) {
          if (Ne && L && typeof Ne.stack == "string") {
            for (var H = Ne.stack.split(`
`), be = L.stack.split(`
`), ce = H.length - 1, le = be.length - 1; ce >= 1 && le >= 0 && H[ce] !== be[le]; )
              le--;
            for (; ce >= 1 && le >= 0; ce--, le--)
              if (H[ce] !== be[le]) {
                if (ce !== 1 || le !== 1)
                  do
                    if (ce--, le--, le < 0 || H[ce] !== be[le]) {
                      var Re = `
` + H[ce].replace(" at new ", " at ");
                      return typeof f == "function" && Y.set(f, Re), Re;
                    }
                  while (ce >= 1 && le >= 0);
                break;
              }
          }
        } finally {
          W = !1, U.current = ne, B(), Error.prepareStackTrace = ae;
        }
        var Ve = f ? f.displayName || f.name : "", kn = Ve ? z(Ve) : "";
        return typeof f == "function" && Y.set(f, kn), kn;
      }
      function se(f, b, k) {
        return C(f, !1);
      }
      function We(f) {
        var b = f.prototype;
        return !!(b && b.isReactComponent);
      }
      function De(f, b, k) {
        if (f == null)
          return "";
        if (typeof f == "function")
          return C(f, We(f));
        if (typeof f == "string")
          return z(f);
        switch (f) {
          case l:
            return z("Suspense");
          case h:
            return z("SuspenseList");
        }
        if (typeof f == "object")
          switch (f.$$typeof) {
            case c:
              return se(f.render);
            case d:
              return De(f.type, b, k);
            case g:
              return se(f._render);
            case m: {
              var L = f, ae = L._payload, ne = L._init;
              try {
                return De(ne(ae), b, k);
              } catch {
              }
            }
          }
        return "";
      }
      var yn = {}, vn = A.ReactDebugCurrentFrame;
      function dt(f) {
        if (f) {
          var b = f._owner, k = De(f.type, f._source, b ? b.type : null);
          vn.setExtraStackFrame(k);
        } else
          vn.setExtraStackFrame(null);
      }
      function pa(f, b, k, L, ae) {
        {
          var ne = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var G in f)
            if (ne(f, G)) {
              var H = void 0;
              try {
                if (typeof f[G] != "function") {
                  var be = Error((L || "React class") + ": " + k + " type `" + G + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof f[G] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw be.name = "Invariant Violation", be;
                }
                H = f[G](b, G, L, k, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ce) {
                H = ce;
              }
              H && !(H instanceof Error) && (dt(ae), R("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", L || "React class", k, G, typeof H), dt(null)), H instanceof Error && !(H.message in yn) && (yn[H.message] = !0, dt(ae), R("Failed %s type: %s", k, H.message), dt(null));
            }
        }
      }
      var bn = A.ReactCurrentOwner, $t = Object.prototype.hasOwnProperty, ga = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, wn, xn;
      function ma(f) {
        if ($t.call(f, "ref")) {
          var b = Object.getOwnPropertyDescriptor(f, "ref").get;
          if (b && b.isReactWarning)
            return !1;
        }
        return f.ref !== void 0;
      }
      function ya(f) {
        if ($t.call(f, "key")) {
          var b = Object.getOwnPropertyDescriptor(f, "key").get;
          if (b && b.isReactWarning)
            return !1;
        }
        return f.key !== void 0;
      }
      function va(f, b) {
        typeof f.ref == "string" && bn.current;
      }
      function ba(f, b) {
        {
          var k = function() {
            wn || (wn = !0, R("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", b));
          };
          k.isReactWarning = !0, Object.defineProperty(f, "key", {
            get: k,
            configurable: !0
          });
        }
      }
      function wa(f, b) {
        {
          var k = function() {
            xn || (xn = !0, R("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", b));
          };
          k.isReactWarning = !0, Object.defineProperty(f, "ref", {
            get: k,
            configurable: !0
          });
        }
      }
      var xa = function(f, b, k, L, ae, ne, G) {
        var H = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: r,
          // Built-in properties that belong on the element
          type: f,
          key: b,
          ref: k,
          props: G,
          // Record the component responsible for creating this element.
          _owner: ne
        };
        return H._store = {}, Object.defineProperty(H._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(H, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: L
        }), Object.defineProperty(H, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: ae
        }), Object.freeze && (Object.freeze(H.props), Object.freeze(H)), H;
      };
      function Ta(f, b, k, L, ae) {
        {
          var ne, G = {}, H = null, be = null;
          k !== void 0 && (H = "" + k), ya(b) && (H = "" + b.key), ma(b) && (be = b.ref, va(b, ae));
          for (ne in b)
            $t.call(b, ne) && !ga.hasOwnProperty(ne) && (G[ne] = b[ne]);
          if (f && f.defaultProps) {
            var ce = f.defaultProps;
            for (ne in ce)
              G[ne] === void 0 && (G[ne] = ce[ne]);
          }
          if (H || be) {
            var le = typeof f == "function" ? f.displayName || f.name || "Unknown" : f;
            H && ba(G, le), be && wa(G, le);
          }
          return xa(f, H, be, ae, L, bn.current, G);
        }
      }
      var Lt = A.ReactCurrentOwner, Tn = A.ReactDebugCurrentFrame;
      function Ye(f) {
        if (f) {
          var b = f._owner, k = De(f.type, f._source, b ? b.type : null);
          Tn.setExtraStackFrame(k);
        } else
          Tn.setExtraStackFrame(null);
      }
      var Dt;
      Dt = !1;
      function _t(f) {
        return typeof f == "object" && f !== null && f.$$typeof === r;
      }
      function Sn() {
        {
          if (Lt.current) {
            var f = te(Lt.current.type);
            if (f)
              return `

Check the render method of \`` + f + "`.";
          }
          return "";
        }
      }
      function Sa(f) {
        return "";
      }
      var En = {};
      function Ea(f) {
        {
          var b = Sn();
          if (!b) {
            var k = typeof f == "string" ? f : f.displayName || f.name;
            k && (b = `

Check the top-level render call using <` + k + ">.");
          }
          return b;
        }
      }
      function On(f, b) {
        {
          if (!f._store || f._store.validated || f.key != null)
            return;
          f._store.validated = !0;
          var k = Ea(b);
          if (En[k])
            return;
          En[k] = !0;
          var L = "";
          f && f._owner && f._owner !== Lt.current && (L = " It was passed a child from " + te(f._owner.type) + "."), Ye(f), R('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', k, L), Ye(null);
        }
      }
      function Cn(f, b) {
        {
          if (typeof f != "object")
            return;
          if (Array.isArray(f))
            for (var k = 0; k < f.length; k++) {
              var L = f[k];
              _t(L) && On(L, b);
            }
          else if (_t(f))
            f._store && (f._store.validated = !0);
          else if (f) {
            var ae = S(f);
            if (typeof ae == "function" && ae !== f.entries)
              for (var ne = ae.call(f), G; !(G = ne.next()).done; )
                _t(G.value) && On(G.value, b);
          }
        }
      }
      function Oa(f) {
        {
          var b = f.type;
          if (b == null || typeof b == "string")
            return;
          var k;
          if (typeof b == "function")
            k = b.propTypes;
          else if (typeof b == "object" && (b.$$typeof === c || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          b.$$typeof === d))
            k = b.propTypes;
          else
            return;
          if (k) {
            var L = te(b);
            pa(k, f.props, "prop", L, f);
          } else if (b.PropTypes !== void 0 && !Dt) {
            Dt = !0;
            var ae = te(b);
            R("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ae || "Unknown");
          }
          typeof b.getDefaultProps == "function" && !b.getDefaultProps.isReactClassApproved && R("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Ca(f) {
        {
          for (var b = Object.keys(f.props), k = 0; k < b.length; k++) {
            var L = b[k];
            if (L !== "children" && L !== "key") {
              Ye(f), R("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", L), Ye(null);
              break;
            }
          }
          f.ref !== null && (Ye(f), R("Invalid attribute `ref` supplied to `React.Fragment`."), Ye(null));
        }
      }
      function Pn(f, b, k, L, ae, ne) {
        {
          var G = q(f);
          if (!G) {
            var H = "";
            (f === void 0 || typeof f == "object" && f !== null && Object.keys(f).length === 0) && (H += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var be = Sa();
            be ? H += be : H += Sn();
            var ce;
            f === null ? ce = "null" : Array.isArray(f) ? ce = "array" : f !== void 0 && f.$$typeof === r ? (ce = "<" + (te(f.type) || "Unknown") + " />", H = " Did you accidentally export a JSX literal instead of a component?") : ce = typeof f, R("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ce, H);
          }
          var le = Ta(f, b, k, ae, ne);
          if (le == null)
            return le;
          if (G) {
            var Re = b.children;
            if (Re !== void 0)
              if (L)
                if (Array.isArray(Re)) {
                  for (var Ve = 0; Ve < Re.length; Ve++)
                    Cn(Re[Ve], f);
                  Object.freeze && Object.freeze(Re);
                } else
                  R("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Cn(Re, f);
          }
          return f === t.Fragment ? Ca(le) : Oa(le), le;
        }
      }
      function Pa(f, b, k) {
        return Pn(f, b, k, !0);
      }
      function ka(f, b, k) {
        return Pn(f, b, k, !1);
      }
      var Ra = ka, Na = Pa;
      t.jsx = Ra, t.jsxs = Na;
    }();
  }(jt)), jt;
}
var $n;
function Ya() {
  return $n || ($n = 1, process.env.NODE_ENV === "production" ? pt.exports = Ua() : pt.exports = Wa()), pt.exports;
}
var N = Ya(), Mt, Ln;
function Va() {
  return Ln || (Ln = 1, Mt = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
  }), Mt;
}
var za = Va();
const qa = /* @__PURE__ */ Or(za);
var Ba = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function Dn(t) {
  var e = { type: "tag", name: "", voidElement: !1, attrs: {}, children: [] }, n = t.match(/<\/?([^\s]+?)[/\s>]/);
  if (n && (e.name = n[1], (qa[n[1]] || t.charAt(t.length - 2) === "/") && (e.voidElement = !0), e.name.startsWith("!--"))) {
    var r = t.indexOf("-->");
    return { type: "comment", comment: r !== -1 ? t.slice(4, r) : "" };
  }
  for (var a = new RegExp(Ba), i = null; (i = a.exec(t)) !== null; ) if (i[0].trim()) if (i[1]) {
    var s = i[1].trim(), o = [s, ""];
    s.indexOf("=") > -1 && (o = s.split("=")), e.attrs[o[0]] = o[1], a.lastIndex--;
  } else i[2] && (e.attrs[i[2]] = i[3].trim().substring(1, i[3].length - 1));
  return e;
}
var Ha = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, Ka = /^\s*$/, Ga = /* @__PURE__ */ Object.create(null);
function Cr(t, e) {
  switch (e.type) {
    case "text":
      return t + e.content;
    case "tag":
      return t += "<" + e.name + (e.attrs ? function(n) {
        var r = [];
        for (var a in n) r.push(a + '="' + n[a] + '"');
        return r.length ? " " + r.join(" ") : "";
      }(e.attrs) : "") + (e.voidElement ? "/>" : ">"), e.voidElement ? t : t + e.children.reduce(Cr, "") + "</" + e.name + ">";
    case "comment":
      return t + "<!--" + e.comment + "-->";
  }
}
var Ja = { parse: function(t, e) {
  e || (e = {}), e.components || (e.components = Ga);
  var n, r = [], a = [], i = -1, s = !1;
  if (t.indexOf("<") !== 0) {
    var o = t.indexOf("<");
    r.push({ type: "text", content: o === -1 ? t : t.substring(0, o) });
  }
  return t.replace(Ha, function(u, c) {
    if (s) {
      if (u !== "</" + n.name + ">") return;
      s = !1;
    }
    var l, h = u.charAt(1) !== "/", d = u.startsWith("<!--"), m = c + u.length, g = t.charAt(m);
    if (d) {
      var w = Dn(u);
      return i < 0 ? (r.push(w), r) : ((l = a[i]).children.push(w), r);
    }
    if (h && (i++, (n = Dn(u)).type === "tag" && e.components[n.name] && (n.type = "component", s = !0), n.voidElement || s || !g || g === "<" || n.children.push({ type: "text", content: t.slice(m, t.indexOf("<", m)) }), i === 0 && r.push(n), (l = a[i - 1]) && l.children.push(n), a[i] = n), (!h || n.voidElement) && (i > -1 && (n.voidElement || n.name === u.slice(2, -1)) && (i--, n = i === -1 ? r : a[i]), !s && g !== "<" && g)) {
      l = i === -1 ? r : a[i].children;
      var y = t.indexOf("<", m), P = t.slice(m, y === -1 ? void 0 : y);
      Ka.test(P) && (P = " "), (y > -1 && i + l.length >= 0 || P !== " ") && l.push({ type: "text", content: P });
    }
  }), r;
}, stringify: function(t) {
  return t.reduce(function(e, n) {
    return e + Cr("", n);
  }, "");
} };
const bt = (...t) => {
  console != null && console.warn && (xe(t[0]) && (t[0] = `react-i18next:: ${t[0]}`), console.warn(...t));
}, _n = {}, ut = (...t) => {
  xe(t[0]) && _n[t[0]] || (xe(t[0]) && (_n[t[0]] = /* @__PURE__ */ new Date()), bt(...t));
}, Pr = (t, e) => () => {
  if (t.isInitialized)
    e();
  else {
    const n = () => {
      setTimeout(() => {
        t.off("initialized", n);
      }, 0), e();
    };
    t.on("initialized", n);
  }
}, Xt = (t, e, n) => {
  t.loadNamespaces(e, Pr(t, n));
}, In = (t, e, n, r) => {
  if (xe(n) && (n = [n]), t.options.preload && t.options.preload.indexOf(e) > -1) return Xt(t, n, r);
  n.forEach((a) => {
    t.options.ns.indexOf(a) < 0 && t.options.ns.push(a);
  }), t.loadLanguages(e, Pr(t, r));
}, Qa = (t, e, n = {}) => !e.languages || !e.languages.length ? (ut("i18n.languages were undefined or empty", e.languages), !0) : e.hasLoadedNamespace(t, {
  lng: n.lng,
  precheck: (r, a) => {
    var i;
    if (((i = n.bindI18n) == null ? void 0 : i.indexOf("languageChanging")) > -1 && r.services.backendConnector.backend && r.isLanguageChangingTo && !a(r.isLanguageChangingTo, t)) return !1;
  }
}), xe = (t) => typeof t == "string", Ue = (t) => typeof t == "object" && t !== null, Xa = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Za = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, ei = (t) => Za[t], ti = (t) => t.replace(Xa, ei);
let Zt = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: ti
};
const ni = (t = {}) => {
  Zt = {
    ...Zt,
    ...t
  };
}, kr = () => Zt;
let Rr;
const ri = (t) => {
  Rr = t;
}, dn = () => Rr, Ft = (t, e) => {
  var r;
  if (!t) return !1;
  const n = ((r = t.props) == null ? void 0 : r.children) ?? t.children;
  return e ? n.length > 0 : !!n;
}, Ut = (t) => {
  var n, r;
  if (!t) return [];
  const e = ((n = t.props) == null ? void 0 : n.children) ?? t.children;
  return (r = t.props) != null && r.i18nIsDynamicList ? Qe(e) : e;
}, ai = (t) => Array.isArray(t) && t.every(xt), Qe = (t) => Array.isArray(t) ? t : [t], ii = (t, e) => {
  const n = {
    ...e
  };
  return n.props = Object.assign(t.props, e.props), n;
}, Nr = (t, e) => {
  if (!t) return "";
  let n = "";
  const r = Qe(t), a = e != null && e.transSupportBasicHtmlNodes ? e.transKeepBasicHtmlNodesFor ?? [] : [];
  return r.forEach((i, s) => {
    if (xe(i))
      n += `${i}`;
    else if (xt(i)) {
      const {
        props: o,
        type: u
      } = i, c = Object.keys(o).length, l = a.indexOf(u) > -1, h = o.children;
      if (!h && l && !c)
        n += `<${u}/>`;
      else if (!h && (!l || c) || o.i18nIsDynamicList)
        n += `<${s}></${s}>`;
      else if (l && c === 1 && xe(h))
        n += `<${u}>${h}</${u}>`;
      else {
        const d = Nr(h, e);
        n += `<${s}>${d}</${s}>`;
      }
    } else if (i === null)
      bt("Trans: the passed in value is invalid - seems you passed in a null child.");
    else if (Ue(i)) {
      const {
        format: o,
        ...u
      } = i, c = Object.keys(u);
      if (c.length === 1) {
        const l = o ? `${c[0]}, ${o}` : c[0];
        n += `{{${l}}}`;
      } else
        bt("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", i);
    } else
      bt("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", i);
  }), n;
}, si = (t, e, n, r, a, i) => {
  if (e === "") return [];
  const s = r.transKeepBasicHtmlNodesFor || [], o = e && new RegExp(s.map((y) => `<${y}`).join("|")).test(e);
  if (!t && !o && !i) return [e];
  const u = {}, c = (y) => {
    Qe(y).forEach((E) => {
      xe(E) || (Ft(E) ? c(Ut(E)) : Ue(E) && !xt(E) && Object.assign(u, E));
    });
  };
  c(t);
  const l = Ja.parse(`<0>${e}</0>`), h = {
    ...u,
    ...a
  }, d = (y, P, E) => {
    var p;
    const x = Ut(y), T = g(x, P.children, E);
    return ai(x) && T.length === 0 || (p = y.props) != null && p.i18nIsDynamicList ? x : T;
  }, m = (y, P, E, x, T) => {
    y.dummy ? (y.children = P, E.push(wr(y, {
      key: x
    }, T ? void 0 : P))) : E.push(...Aa.map([y], (p) => {
      const S = {
        ...p.props
      };
      return delete S.i18nIsDynamicList, Fe(p.type, {
        ...S,
        key: x,
        ref: p.ref
      }, T ? null : P);
    }));
  }, g = (y, P, E) => {
    const x = Qe(y);
    return Qe(P).reduce((p, S, A) => {
      var V, J;
      const R = ((J = (V = S.children) == null ? void 0 : V[0]) == null ? void 0 : J.content) && n.services.interpolator.interpolate(S.children[0].content, h, n.language);
      if (S.type === "tag") {
        let q = x[parseInt(S.name, 10)];
        E.length === 1 && !q && (q = E[0][S.name]), q || (q = {});
        const ee = Object.keys(S.attrs).length !== 0 ? ii({
          props: S.attrs
        }, q) : q, pe = xt(ee), te = pe && Ft(S, !0) && !S.voidElement, oe = o && Ue(ee) && ee.dummy && !pe, ie = Ue(t) && Object.hasOwnProperty.call(t, S.name);
        if (xe(ee)) {
          const K = n.services.interpolator.interpolate(ee, h, n.language);
          p.push(K);
        } else if (Ft(ee) || te) {
          const K = d(ee, S, E);
          m(ee, K, p, A);
        } else if (oe) {
          const K = g(x, S.children, E);
          m(ee, K, p, A);
        } else if (Number.isNaN(parseFloat(S.name)))
          if (ie) {
            const K = d(ee, S, E);
            m(ee, K, p, A, S.voidElement);
          } else if (r.transSupportBasicHtmlNodes && s.indexOf(S.name) > -1)
            if (S.voidElement)
              p.push(Fe(S.name, {
                key: `${S.name}-${A}`
              }));
            else {
              const K = g(x, S.children, E);
              p.push(Fe(S.name, {
                key: `${S.name}-${A}`
              }, K));
            }
          else if (S.voidElement)
            p.push(`<${S.name} />`);
          else {
            const K = g(x, S.children, E);
            p.push(`<${S.name}>${K}</${S.name}>`);
          }
        else if (Ue(ee) && !pe) {
          const K = S.children[0] ? R : null;
          K && p.push(K);
        } else
          m(ee, R, p, A, S.children.length !== 1 || !R);
      } else if (S.type === "text") {
        const q = r.transWrapTextNodes, ee = i ? r.unescape(n.services.interpolator.interpolate(S.content, h, n.language)) : n.services.interpolator.interpolate(S.content, h, n.language);
        q ? p.push(Fe(q, {
          key: `${S.name}-${A}`
        }, ee)) : p.push(ee);
      }
      return p;
    }, []);
  }, w = g([{
    dummy: !0,
    children: t || []
  }], l, Qe(t || []));
  return Ut(w[0]);
}, Ar = (t, e, n) => {
  const r = t.key || e, a = wr(t, {
    key: r
  });
  if (!a.props || !a.props.children || n.indexOf(`${e}/>`) < 0 && n.indexOf(`${e} />`) < 0)
    return a;
  function i() {
    return Fe($a, null, a);
  }
  return Fe(i);
}, oi = (t, e) => t.map((n, r) => Ar(n, r, e)), ui = (t, e) => {
  const n = {};
  return Object.keys(t).forEach((r) => {
    Object.assign(n, {
      [r]: Ar(t[r], r, e)
    });
  }), n;
}, ci = (t, e) => t ? Array.isArray(t) ? oi(t, e) : Ue(t) ? ui(t, e) : (ut("<Trans /> component prop expects an object or an array"), null) : null;
function li({
  children: t,
  count: e,
  parent: n,
  i18nKey: r,
  context: a,
  tOptions: i = {},
  values: s,
  defaults: o,
  components: u,
  ns: c,
  i18n: l,
  t: h,
  shouldUnescape: d,
  ...m
}) {
  var ee, pe, te, oe, ie, K;
  const g = l || dn();
  if (!g)
    return ut("You will need to pass in an i18next instance by using i18nextReactModule"), t;
  const w = h || g.t.bind(g) || ((re) => re), y = {
    ...kr(),
    ...(ee = g.options) == null ? void 0 : ee.react
  };
  let P = c || w.ns || ((pe = g.options) == null ? void 0 : pe.defaultNS);
  P = xe(P) ? [P] : P || ["translation"];
  const E = Nr(t, y), x = o || E || y.transEmptyNodeValue || r, {
    hashTransKey: T
  } = y, p = r || (T ? T(E || x) : E || x);
  (oe = (te = g.options) == null ? void 0 : te.interpolation) != null && oe.defaultVariables && (s = s && Object.keys(s).length > 0 ? {
    ...s,
    ...g.options.interpolation.defaultVariables
  } : {
    ...g.options.interpolation.defaultVariables
  });
  const S = s || e !== void 0 && !((K = (ie = g.options) == null ? void 0 : ie.interpolation) != null && K.alwaysFormat) || !t ? i.interpolation : {
    interpolation: {
      ...i.interpolation,
      prefix: "#$?",
      suffix: "?$#"
    }
  }, A = {
    ...i,
    context: a || i.context,
    count: e,
    ...s,
    ...S,
    defaultValue: x,
    ns: P
  }, R = p ? w(p, A) : x, V = ci(u, R), J = si(V || t, R, g, y, A, d), q = n ?? y.defaultTransParent;
  return q ? Fe(q, m, J) : J;
}
const fi = {
  type: "3rdParty",
  init(t) {
    ni(t.options.react), ri(t);
  }
}, $r = xr();
class di {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(e) {
    e.forEach((n) => {
      this.usedNamespaces[n] || (this.usedNamespaces[n] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
function en({
  children: t,
  count: e,
  parent: n,
  i18nKey: r,
  context: a,
  tOptions: i = {},
  values: s,
  defaults: o,
  components: u,
  ns: c,
  i18n: l,
  t: h,
  shouldUnescape: d,
  ...m
}) {
  var E;
  const {
    i18n: g,
    defaultNS: w
  } = un($r) || {}, y = l || g || dn(), P = h || (y == null ? void 0 : y.t.bind(y));
  return li({
    children: t,
    count: e,
    parent: n,
    i18nKey: r,
    context: a,
    tOptions: i,
    values: s,
    defaults: o,
    components: u,
    ns: c || (P == null ? void 0 : P.ns) || w || ((E = y == null ? void 0 : y.options) == null ? void 0 : E.defaultNS),
    i18n: y,
    t: h,
    shouldUnescape: d,
    ...m
  });
}
const hi = (t, e) => {
  const n = cn();
  return we(() => {
    n.current = t;
  }, [t, e]), n.current;
}, Lr = (t, e, n, r) => t.getFixedT(e, n, r), pi = (t, e, n, r) => Ge(Lr(t, e, n, r), [t, e, n, r]), ft = (t, e = {}) => {
  var T, p, S, A;
  const {
    i18n: n
  } = e, {
    i18n: r,
    defaultNS: a
  } = un($r) || {}, i = n || r || dn();
  if (i && !i.reportNamespaces && (i.reportNamespaces = new di()), !i) {
    ut("You will need to pass in an i18next instance by using initReactI18next");
    const R = (J, q) => xe(q) ? q : Ue(q) && xe(q.defaultValue) ? q.defaultValue : Array.isArray(J) ? J[J.length - 1] : J, V = [R, {}, !1];
    return V.t = R, V.i18n = {}, V.ready = !1, V;
  }
  (T = i.options.react) != null && T.wait && ut("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const s = {
    ...kr(),
    ...i.options.react,
    ...e
  }, {
    useSuspense: o,
    keyPrefix: u
  } = s;
  let c = a || ((p = i.options) == null ? void 0 : p.defaultNS);
  c = xe(c) ? [c] : c || ["translation"], (A = (S = i.reportNamespaces).addUsedNamespaces) == null || A.call(S, c);
  const l = (i.isInitialized || i.initializedStoreOnce) && c.every((R) => Qa(R, i, s)), h = pi(i, e.lng || null, s.nsMode === "fallback" ? c : c[0], u), d = () => h, m = () => Lr(i, e.lng || null, s.nsMode === "fallback" ? c : c[0], u), [g, w] = Te(d);
  let y = c.join();
  e.lng && (y = `${e.lng}${y}`);
  const P = hi(y), E = cn(!0);
  we(() => {
    const {
      bindI18n: R,
      bindI18nStore: V
    } = s;
    E.current = !0, !l && !o && (e.lng ? In(i, e.lng, c, () => {
      E.current && w(m);
    }) : Xt(i, c, () => {
      E.current && w(m);
    })), l && P && P !== y && E.current && w(m);
    const J = () => {
      E.current && w(m);
    };
    return R && (i == null || i.on(R, J)), V && (i == null || i.store.on(V, J)), () => {
      E.current = !1, i && (R == null || R.split(" ").forEach((q) => i.off(q, J))), V && i && V.split(" ").forEach((q) => i.store.off(q, J));
    };
  }, [i, y]), we(() => {
    E.current && l && w(d);
  }, [i, u, l]);
  const x = [g, i, l];
  if (x.t = g, x.i18n = i, x.ready = l, l || !l && !o) return x;
  throw new Promise((R) => {
    e.lng ? In(i, e.lng, c, () => R()) : Xt(i, c, () => R());
  });
}, { Modal: gi, Inner: mi, Content: yi, Footer: vi } = Ma, bi = (t) => {
  const { t: e } = ft(), { toggleModal: n, modalIsOpen: r } = t;
  return /* @__PURE__ */ N.jsx(gi, { isOpen: r, onRequestClose: () => n(!1), children: /* @__PURE__ */ N.jsxs(mi, { children: [
    /* @__PURE__ */ N.jsxs(yi, { children: [
      /* @__PURE__ */ N.jsx(Ia, { level: "3", children: e("Option not available") }),
      /* @__PURE__ */ N.jsx(ja, { children: e(
        "Your access level does not allow you to perform this action, contact the owner of the account to increase your level of access."
      ) })
    ] }),
    /* @__PURE__ */ N.jsx(vi, { footer: /* @__PURE__ */ N.jsx(ln, { onClick: () => n(!1), size: "large", color: "danger", label: e("close") }) })
  ] }) });
}, wi = {
  [$.idle]: "refresh",
  [$.inactive]: "refresh",
  [$.success]: "checkAlone",
  [$.empty]: "warningCircle",
  [$.api_error]: "close",
  [$.user_error]: "close",
  [$.warning]: "warningCircle",
  [$.error]: "close",
  [$.pending]: "refresh"
}, xi = {
  [$.idle]: "grey",
  [$.inactive]: "grey",
  [$.success]: "green",
  [$.empty]: "danger",
  [$.api_error]: "danger",
  [$.user_error]: "danger",
  [$.warning]: "warning",
  [$.error]: "danger",
  [$.pending]: "primary"
}, Ti = Se(ln)`
  display: flex !important;
  justify-content: space-between !important;
  padding: 4px 12px 4px 8px !important;
  border: 2px solid ${({ theme: t }) => t.dec.color.primary.default.sk.minimal};
  border-radius: 20px;
  min-width: 74px !important;
  height: 32px !important;

  svg {
    margin: 0 !important;
  }

  ${({ status: t, theme: e }) => t === $.idle && ye`
      &:hover {
        border-color: ${e.dec.color.primary.default.fg.brand};

        svg {
          transform: rotate(90deg);
        }
      }

      svg {
        transition: transform 0.5s ease-in-out;
      }
    `}

  ${({ status: t, theme: e }) => t === $.inactive && ye`
      color: ${e.dec.color.primary.default.fg.minimal} !important;
    `}
  ${({ status: t }) => t === $.pending && ye`
      justify-content: space-around !important;
    `}

  ${({ status: t }) => t && [$.inactive, $.empty].includes(t) && ye`
      pointer-events: none;
      user-select: none;
      cursor: not-allowed;
    `}
`, Wt = ({ status: t, onClick: e }) => {
  const { t: n } = ft();
  return /* @__PURE__ */ N.jsx(
    Ti,
    {
      onClick: e,
      label: t === $.pending ? /* @__PURE__ */ N.jsx(Sr, {}) : n("Tag"),
      icon: t !== $.pending ? wi[t] : void 0,
      status: t,
      size: "medium",
      variant: "outlined",
      color: xi[t],
      "aria-disabled": [$.inactive, $.empty].includes(t),
      "data-testid": "tag-refresh-button"
    }
  );
}, Si = (t) => {
  switch (t) {
    case $.success:
      return "Success";
    case $.empty:
    case $.error:
    case $.api_error:
    case $.user_error:
      return "Error";
    case $.warning:
      return "Warning";
    default:
      return "Info";
  }
};
function St(t) {
  try {
    return !!JSON.parse(t ?? "[]").length;
  } catch {
    return !1;
  }
}
const Ei = Se.div`
  line-height: 1.42;
`, Oi = Se.span`
  color: ${({ theme: t }) => t.dec.color.primary.active.fg.norm};
`;
function Ci(t, e) {
  switch (e) {
    case "Error":
      return t.dec.color.primary.default.fg.negative;
    case "Success":
      return t.dec.color.positiveSubbtle.default.fg.flash;
    case "Warning":
      return t.dec.color.primary.default.fg.moderate;
    case "Info":
      return t.dec.color.primary.default.fg.brand;
    default:
      return;
  }
}
const hn = Se(Fa)`
  ${({ type: t, theme: e }) => t === "default" && ye`
      .Popover-body {
        border: 2px solid;
        background: ${e.dec.color.primary.default.bg.norm};
        color: ${e.dec.color.primary.default.sk.maximal};
      }
    `}

  ${({ status: t, theme: e }) => t === "Info" && ye`
      .Popover-body,
      .tooltip-arrow {
        border-color: ${e.dec.color.primary.default.fg.brand};
      }

      .tooltip-arrow {
        background-color: ${e.dec.color.primary.default.fg.brand}
    `}

    ${({ status: t, theme: e }) => t === "Success" && ye`
      .Popover-body,
      .tooltip-arrow {
        border-color: ${e.dec.color.positiveSubbtle.default.fg.flash};
      }

      .tooltip-arrow {
        background-color: ${e.dec.color.positiveSubbtle.default.fg.flash} !important;
      }
    `}
    ${({ status: t, theme: e }) => t === "Error" && ye`
      .Popover-body,
      .tooltip-arrow {
        border-color: ${e.dec.color.primary.default.fg.negative};
      }

      .tooltip-arrow {
        background-color: ${e.dec.color.primary.default.fg.negative} !important;
      }
    `}

    ${({ status: t, theme: e }) => t === "Warning" && ye`
      .Popover-body,
      .tooltip-arrow {
        border-color: ${e.dec.color.moderateSubbtle.default.sk.norm};
      }

      .tooltip-arrow {
        background-color: ${e.dec.color.moderateSubbtle.default.sk.norm} !important;
      }
    `}
    ${({ status: t }) => t === "Inactive" && ye`
      .Popover-body {
        border-radius: 4px;
        font-weight: normal;
        padding: 12px;
        max-height: none;
        height: auto;
        white-space: normal;
      }
    `}

    ${({ zIndex: t, theme: e }) => t && ye`
      z-index: ${e.general.tooltipZindex};
    `}

    a {
    margin: 0 3px;

    ${({ status: t, theme: e }) => ye`
      color: ${Ci(e, t)};
    `}

    &:hover {
      text-decoration: underline;
    }
  }
`, Dr = Se.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 10px;

  a {
    color: ${({ theme: t }) => t.dec.color.primary.error.fg.norm};
  }

  * + * {
    margin-left: 10px;
  }
`, pn = () => {
  const { t } = ft();
  return {
    reminder: t("Please update the tag to validate your changes."),
    failed: t("Sorry, your tag has not been updated as we encountered an error on our side... Please try again later."),
    failed_info: (e) => t(
      "Last successful update: {{- lastUpdate}}. All the modifications you have made after this time are not live on your website.",
      { lastUpdate: e }
    ),
    succeeded: (e) => e ? t("Your tag has been successfully updated on the {{- lastUpdate}}", {
      lastUpdate: e
    }) : t("Your tag has been successfully updated"),
    succeeded_info: t("All the modifications you have made before this time are currently live on your website."),
    failedWithErrors: (e) => /* @__PURE__ */ N.jsxs(en, { t, children: [
      "Oops, you tag has not been updated as we have detected errors on you account. Please",
      " ",
      /* @__PURE__ */ N.jsx("a", { href: e, children: "check and correct them" }),
      " before updating your tag again."
    ] }),
    warning: (e) => /* @__PURE__ */ N.jsxs(en, { t, children: [
      "Oops, your tag has been updated but we have detected errors on your account. Please",
      " ",
      /* @__PURE__ */ N.jsx("a", { href: e, children: "check and correct them" }),
      " before updating your tag again."
    ] })
  };
}, Pi = ({ status: t, version: e, lastUpdate: n, frameworkSettingsUrl: r, children: a }) => {
  const { t: i } = ft(), { failed: s, failedWithErrors: o } = pn(), u = () => e ? /* @__PURE__ */ N.jsxs(N.Fragment, { children: [
    i("Tag version: "),
    " ",
    /* @__PURE__ */ N.jsx(Oi, { children: e })
  ] }) : null;
  return /* @__PURE__ */ N.jsx(
    hn,
    {
      content: /* @__PURE__ */ N.jsx(N.Fragment, { children: t === $.inactive ? i("You can't update your tag as your account is currently inactive.") : t === $.empty ? i(
        `It looks like your AB Tasty library is empty. This means that your campaigns are temporarily deactivated.
  To continue running you campaigns, click Recreate library directly from the dashboard or Rebuild framework in the Settings.`
      ) : t === $.user_error ? o(r) : [$.api_error, $.error].includes(t) ? s : /* @__PURE__ */ N.jsxs(Ei, { children: [
        /* @__PURE__ */ N.jsxs("p", { children: [
          /* @__PURE__ */ N.jsx(u, {}),
          n ? ` - ${i("Last update : ")} ${n}` : null
        ] }),
        /* @__PURE__ */ N.jsxs(Dr, { children: [
          /* @__PURE__ */ N.jsx(Tt, { icon: "warningCircle", size: "small", color: "mustard" }),
          /* @__PURE__ */ N.jsx("p", { children: t === $.warning ? /* @__PURE__ */ N.jsxs(en, { t: i, children: [
            "Last update has been forced. The identified error(s) are still present on your account. Please",
            " ",
            /* @__PURE__ */ N.jsx("a", { href: r, children: "check and correct them" }),
            " before updating your tag again."
          ] }) : i(
            "Once you update the tag, all changes made to your active campaigns and/or account settings since the last update will be visible in production."
          ) })
        ] })
      ] }) }),
      type: t === $.inactive ? "small" : "default",
      status: t !== $.inactive ? Si(t) : "Inactive",
      className: "tag-refresh-tooltip",
      children: a
    }
  );
};
var ve = /* @__PURE__ */ ((t) => (t.success = "success", t.warning = "warning", t.reminder = "reminder", t.fail = "fail", t.error = "error", t))(ve || {});
const ki = (t, e) => {
  switch (e) {
    case ve.success:
      return t.dec.color.positiveSubbtle.default.fg.flash;
    case ve.reminder:
      return t.dec.color.primary.default.fg.brand;
    case ve.warning:
      return t.dec.color.primary.default.fg.moderate;
    case ve.error:
    case ve.fail:
      return t.dec.color.primary.default.fg.negative;
    default:
      return;
  }
}, Ri = Se.div`
  a {
    margin: 0 3px;

    ${({ type: t, theme: e }) => ye`
      color: ${ki(e, t)};
    `}

    &:hover {
      text-decoration: underline;
    }
  }
`, Ni = ({
  type: t,
  label: e,
  description: n,
  hideNotification: r,
  children: a
}) => {
  let i, s;
  switch (t) {
    case ve.success:
      i = "darkGreen", s = "Success";
      break;
    case ve.fail:
    case ve.error:
      i = "red", s = "Error";
      break;
    case ve.reminder:
      i = "abBlue", s = "Info";
      break;
    case ve.warning:
      i = "mustard", s = "Warning";
      break;
  }
  return /* @__PURE__ */ N.jsx(
    hn,
    {
      className: "tag-refresh-tooltip",
      type: "default",
      isVisible: !0,
      content: /* @__PURE__ */ N.jsxs(Ri, { onClick: r, "data-testid": "notification", type: t, children: [
        e,
        n && /* @__PURE__ */ N.jsxs(Dr, { children: [
          /* @__PURE__ */ N.jsx(Tt, { icon: "warningCircle", color: i }),
          /* @__PURE__ */ N.jsx("p", { children: n })
        ] })
      ] }),
      status: s,
      zIndex: !0,
      children: a
    }
  );
};
var fe = /* @__PURE__ */ ((t) => (t[t.request = 0] = "request", t[t.compilation = 1] = "compilation", t[t.server = 2] = "server", t[t.publishment = 3] = "publishment", t[t.done = 4] = "done", t))(fe || {});
const Ai = Er`
from {
    transform: scale(1.1);
  }

  to {
    transform: scale(1);
  }
`, jn = Er`
from {
    opacity: 0.3;
    transform: scale(0.5);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
`, _e = Se.span`
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: relative;
  margin-right: 5px;
  width: 14px;
  height: 14px;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    outline: 2px solid ${({ theme: t }) => t.dec.color.primary.default.bg.norm};
    border-radius: 5px;
    background: ${({ theme: t }) => t.dec.color.primary.default.sk.minimal};
  }

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin: auto;
    width: 2px;
    height: 12px;
    background: ${({ theme: t }) => t.dec.color.primary.default.sk.minimal};
    z-index: -1;
  }

  svg {
    position: relative;
  }
`, wt = Se.span`
  &::after {
    content: attr(title);
    display: block;
    height: 1px;
    color: transparent;
    font-weight: bold;
    overflow: hidden;
    visibility: hidden;
  }
`, $i = Se.li`
  display: flex;
  align-items: center;
  position: relative;

  &:not(:last-child) {
    margin-bottom: 12px;
  }

  &:last-child ${_e}::after {
    opacity: 0;
  }

  ${({ status: t, theme: e }) => t === "success" && ye`
      ${_e} {
        &::before,
        &::after {
          background: ${e.dec.color.positiveSubbtle.default.fg.flash};
        }

        &::before,
        svg {
          animation: ${jn} 0.5s;
        }
      }

      ${wt} {
        color: ${e.dec.color.positiveSubbtle.default.fg.flash};
      }
    `}

  ${({ status: t, theme: e }) => t === "error" && ye`
      &:not(:first-child) ${_e}::after, & ~ li ${_e}::after {
        top: auto;
        bottom: 100%;
        opacity: 1 !important;
      }

      ${_e} {
        &::before,
        &::after {
          background: ${e.dec.color.primary.default.fg.negative};
        }

        &::before,
        svg {
          animation: ${jn} 0.75s;
        }
      }

      ${wt} {
        color: ${e.dec.color.primary.default.fg.negative};
      }
    `}

    ${({ status: t, theme: e }) => t === "in progress" && ye`
      ${_e}::before {
        background: ${e.dec.color.primary.default.bg.norm};
        border: 1px solid ${e.dec.color.primary.default.fg.minimal};
        animation: ${Ai} 0.5s ease-in-out 0s infinite alternate;
      }

      ${wt} {
        font-weight: bold;
      }
    `}
`, Li = (t) => {
  const { t: e } = ft();
  return {
    [fe.request]: e("Sending request"),
    [fe.compilation]: e("Processing compilation"),
    [fe.server]: e("Sending to server"),
    [fe.publishment]: e("Publishing modifications")
  }[t];
}, Di = ({ status: t, step: e }) => {
  const n = Li(e), r = fe[e];
  return /* @__PURE__ */ N.jsxs($i, { status: t, "data-testid": `progress-step-${r}-${t.split(" ").join("")}`, children: [
    /* @__PURE__ */ N.jsx(_e, { children: t === "success" ? /* @__PURE__ */ N.jsx(Tt, { icon: "checkAlone", color: "white", customSize: 10 }) : t === "error" ? /* @__PURE__ */ N.jsx(Tt, { icon: "close", color: "white", customSize: 10 }) : null }),
    /* @__PURE__ */ N.jsx(wt, { title: n, children: n })
  ] });
}, _i = [
  fe.request,
  fe.compilation,
  fe.server,
  fe.publishment
], Ii = ({ step: t, error: e = !1 }) => /* @__PURE__ */ N.jsx("ul", { children: _i.map((n) => /* @__PURE__ */ N.jsx(
  Di,
  {
    status: t === n ? e ? "error" : "in progress" : t < n ? "waiting" : "success",
    step: n
  },
  n
)) });
function Et() {
  return Et = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Et.apply(null, arguments);
}
function _r(t, e) {
  if (t == null) return {};
  var n = {};
  for (var r in t) if ({}.hasOwnProperty.call(t, r)) {
    if (e.includes(r)) continue;
    n[r] = t[r];
  }
  return n;
}
function tn(t, e) {
  return tn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, tn(t, e);
}
function Ir(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, tn(t, e);
}
var gt = { exports: {} }, mt = { exports: {} }, Q = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mn;
function ji() {
  if (Mn) return Q;
  Mn = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, o = t ? Symbol.for("react.context") : 60110, u = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, l = t ? Symbol.for("react.forward_ref") : 60112, h = t ? Symbol.for("react.suspense") : 60113, d = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, g = t ? Symbol.for("react.lazy") : 60116, w = t ? Symbol.for("react.block") : 60121, y = t ? Symbol.for("react.fundamental") : 60117, P = t ? Symbol.for("react.responder") : 60118, E = t ? Symbol.for("react.scope") : 60119;
  function x(p) {
    if (typeof p == "object" && p !== null) {
      var S = p.$$typeof;
      switch (S) {
        case e:
          switch (p = p.type, p) {
            case u:
            case c:
            case r:
            case i:
            case a:
            case h:
              return p;
            default:
              switch (p = p && p.$$typeof, p) {
                case o:
                case l:
                case g:
                case m:
                case s:
                  return p;
                default:
                  return S;
              }
          }
        case n:
          return S;
      }
    }
  }
  function T(p) {
    return x(p) === c;
  }
  return Q.AsyncMode = u, Q.ConcurrentMode = c, Q.ContextConsumer = o, Q.ContextProvider = s, Q.Element = e, Q.ForwardRef = l, Q.Fragment = r, Q.Lazy = g, Q.Memo = m, Q.Portal = n, Q.Profiler = i, Q.StrictMode = a, Q.Suspense = h, Q.isAsyncMode = function(p) {
    return T(p) || x(p) === u;
  }, Q.isConcurrentMode = T, Q.isContextConsumer = function(p) {
    return x(p) === o;
  }, Q.isContextProvider = function(p) {
    return x(p) === s;
  }, Q.isElement = function(p) {
    return typeof p == "object" && p !== null && p.$$typeof === e;
  }, Q.isForwardRef = function(p) {
    return x(p) === l;
  }, Q.isFragment = function(p) {
    return x(p) === r;
  }, Q.isLazy = function(p) {
    return x(p) === g;
  }, Q.isMemo = function(p) {
    return x(p) === m;
  }, Q.isPortal = function(p) {
    return x(p) === n;
  }, Q.isProfiler = function(p) {
    return x(p) === i;
  }, Q.isStrictMode = function(p) {
    return x(p) === a;
  }, Q.isSuspense = function(p) {
    return x(p) === h;
  }, Q.isValidElementType = function(p) {
    return typeof p == "string" || typeof p == "function" || p === r || p === c || p === i || p === a || p === h || p === d || typeof p == "object" && p !== null && (p.$$typeof === g || p.$$typeof === m || p.$$typeof === s || p.$$typeof === o || p.$$typeof === l || p.$$typeof === y || p.$$typeof === P || p.$$typeof === E || p.$$typeof === w);
  }, Q.typeOf = x, Q;
}
var X = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fn;
function Mi() {
  return Fn || (Fn = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, o = t ? Symbol.for("react.context") : 60110, u = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, l = t ? Symbol.for("react.forward_ref") : 60112, h = t ? Symbol.for("react.suspense") : 60113, d = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, g = t ? Symbol.for("react.lazy") : 60116, w = t ? Symbol.for("react.block") : 60121, y = t ? Symbol.for("react.fundamental") : 60117, P = t ? Symbol.for("react.responder") : 60118, E = t ? Symbol.for("react.scope") : 60119;
    function x(C) {
      return typeof C == "string" || typeof C == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      C === r || C === c || C === i || C === a || C === h || C === d || typeof C == "object" && C !== null && (C.$$typeof === g || C.$$typeof === m || C.$$typeof === s || C.$$typeof === o || C.$$typeof === l || C.$$typeof === y || C.$$typeof === P || C.$$typeof === E || C.$$typeof === w);
    }
    function T(C) {
      if (typeof C == "object" && C !== null) {
        var se = C.$$typeof;
        switch (se) {
          case e:
            var We = C.type;
            switch (We) {
              case u:
              case c:
              case r:
              case i:
              case a:
              case h:
                return We;
              default:
                var De = We && We.$$typeof;
                switch (De) {
                  case o:
                  case l:
                  case g:
                  case m:
                  case s:
                    return De;
                  default:
                    return se;
                }
            }
          case n:
            return se;
        }
      }
    }
    var p = u, S = c, A = o, R = s, V = e, J = l, q = r, ee = g, pe = m, te = n, oe = i, ie = a, K = h, re = !1;
    function de(C) {
      return re || (re = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), v(C) || T(C) === u;
    }
    function v(C) {
      return T(C) === c;
    }
    function O(C) {
      return T(C) === o;
    }
    function D(C) {
      return T(C) === s;
    }
    function j(C) {
      return typeof C == "object" && C !== null && C.$$typeof === e;
    }
    function _(C) {
      return T(C) === l;
    }
    function B(C) {
      return T(C) === r;
    }
    function U(C) {
      return T(C) === g;
    }
    function M(C) {
      return T(C) === m;
    }
    function z(C) {
      return T(C) === n;
    }
    function W(C) {
      return T(C) === i;
    }
    function Y(C) {
      return T(C) === a;
    }
    function he(C) {
      return T(C) === h;
    }
    X.AsyncMode = p, X.ConcurrentMode = S, X.ContextConsumer = A, X.ContextProvider = R, X.Element = V, X.ForwardRef = J, X.Fragment = q, X.Lazy = ee, X.Memo = pe, X.Portal = te, X.Profiler = oe, X.StrictMode = ie, X.Suspense = K, X.isAsyncMode = de, X.isConcurrentMode = v, X.isContextConsumer = O, X.isContextProvider = D, X.isElement = j, X.isForwardRef = _, X.isFragment = B, X.isLazy = U, X.isMemo = M, X.isPortal = z, X.isProfiler = W, X.isStrictMode = Y, X.isSuspense = he, X.isValidElementType = x, X.typeOf = T;
  }()), X;
}
var Un;
function jr() {
  return Un || (Un = 1, process.env.NODE_ENV === "production" ? mt.exports = ji() : mt.exports = Mi()), mt.exports;
}
var Yt, Wn;
function gn() {
  if (Wn) return Yt;
  Wn = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Yt = t, Yt;
}
var Vt, Yn;
function Mr() {
  return Yn || (Yn = 1, Vt = Function.call.bind(Object.prototype.hasOwnProperty)), Vt;
}
var zt, Vn;
function Fi() {
  if (Vn) return zt;
  Vn = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */ gn(), n = {}, r = /* @__PURE__ */ Mr();
    t = function(i) {
      var s = "Warning: " + i;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function a(i, s, o, u, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in i)
        if (r(i, l)) {
          var h;
          try {
            if (typeof i[l] != "function") {
              var d = Error(
                (u || "React class") + ": " + o + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            h = i[l](s, l, u, o, null, e);
          } catch (g) {
            h = g;
          }
          if (h && !(h instanceof Error) && t(
            (u || "React class") + ": type specification of " + o + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in n)) {
            n[h.message] = !0;
            var m = c ? c() : "";
            t(
              "Failed " + o + " type: " + h.message + (m ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, zt = a, zt;
}
var qt, zn;
function Ui() {
  if (zn) return qt;
  zn = 1;
  var t = jr(), e = fn(), n = /* @__PURE__ */ gn(), r = /* @__PURE__ */ Mr(), a = /* @__PURE__ */ Fi(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(o) {
    var u = "Warning: " + o;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return qt = function(o, u) {
    var c = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
    function h(v) {
      var O = v && (c && v[c] || v[l]);
      if (typeof O == "function")
        return O;
    }
    var d = "<<anonymous>>", m = {
      array: P("array"),
      bigint: P("bigint"),
      bool: P("boolean"),
      func: P("function"),
      number: P("number"),
      object: P("object"),
      string: P("string"),
      symbol: P("symbol"),
      any: E(),
      arrayOf: x,
      element: T(),
      elementType: p(),
      instanceOf: S,
      node: J(),
      objectOf: R,
      oneOf: A,
      oneOfType: V,
      shape: ee,
      exact: pe
    };
    function g(v, O) {
      return v === O ? v !== 0 || 1 / v === 1 / O : v !== v && O !== O;
    }
    function w(v, O) {
      this.message = v, this.data = O && typeof O == "object" ? O : {}, this.stack = "";
    }
    w.prototype = Error.prototype;
    function y(v) {
      if (process.env.NODE_ENV !== "production")
        var O = {}, D = 0;
      function j(B, U, M, z, W, Y, he) {
        if (z = z || d, Y = Y || M, he !== n) {
          if (u) {
            var C = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw C.name = "Invariant Violation", C;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var se = z + ":" + M;
            !O[se] && // Avoid spamming the console because they are often not actionable except for lib authors
            D < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + Y + "` prop on `" + z + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), O[se] = !0, D++);
          }
        }
        return U[M] == null ? B ? U[M] === null ? new w("The " + W + " `" + Y + "` is marked as required " + ("in `" + z + "`, but its value is `null`.")) : new w("The " + W + " `" + Y + "` is marked as required in " + ("`" + z + "`, but its value is `undefined`.")) : null : v(U, M, z, W, Y);
      }
      var _ = j.bind(null, !1);
      return _.isRequired = j.bind(null, !0), _;
    }
    function P(v) {
      function O(D, j, _, B, U, M) {
        var z = D[j], W = ie(z);
        if (W !== v) {
          var Y = K(z);
          return new w(
            "Invalid " + B + " `" + U + "` of type " + ("`" + Y + "` supplied to `" + _ + "`, expected ") + ("`" + v + "`."),
            { expectedType: v }
          );
        }
        return null;
      }
      return y(O);
    }
    function E() {
      return y(s);
    }
    function x(v) {
      function O(D, j, _, B, U) {
        if (typeof v != "function")
          return new w("Property `" + U + "` of component `" + _ + "` has invalid PropType notation inside arrayOf.");
        var M = D[j];
        if (!Array.isArray(M)) {
          var z = ie(M);
          return new w("Invalid " + B + " `" + U + "` of type " + ("`" + z + "` supplied to `" + _ + "`, expected an array."));
        }
        for (var W = 0; W < M.length; W++) {
          var Y = v(M, W, _, B, U + "[" + W + "]", n);
          if (Y instanceof Error)
            return Y;
        }
        return null;
      }
      return y(O);
    }
    function T() {
      function v(O, D, j, _, B) {
        var U = O[D];
        if (!o(U)) {
          var M = ie(U);
          return new w("Invalid " + _ + " `" + B + "` of type " + ("`" + M + "` supplied to `" + j + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(v);
    }
    function p() {
      function v(O, D, j, _, B) {
        var U = O[D];
        if (!t.isValidElementType(U)) {
          var M = ie(U);
          return new w("Invalid " + _ + " `" + B + "` of type " + ("`" + M + "` supplied to `" + j + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(v);
    }
    function S(v) {
      function O(D, j, _, B, U) {
        if (!(D[j] instanceof v)) {
          var M = v.name || d, z = de(D[j]);
          return new w("Invalid " + B + " `" + U + "` of type " + ("`" + z + "` supplied to `" + _ + "`, expected ") + ("instance of `" + M + "`."));
        }
        return null;
      }
      return y(O);
    }
    function A(v) {
      if (!Array.isArray(v))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function O(D, j, _, B, U) {
        for (var M = D[j], z = 0; z < v.length; z++)
          if (g(M, v[z]))
            return null;
        var W = JSON.stringify(v, function(he, C) {
          var se = K(C);
          return se === "symbol" ? String(C) : C;
        });
        return new w("Invalid " + B + " `" + U + "` of value `" + String(M) + "` " + ("supplied to `" + _ + "`, expected one of " + W + "."));
      }
      return y(O);
    }
    function R(v) {
      function O(D, j, _, B, U) {
        if (typeof v != "function")
          return new w("Property `" + U + "` of component `" + _ + "` has invalid PropType notation inside objectOf.");
        var M = D[j], z = ie(M);
        if (z !== "object")
          return new w("Invalid " + B + " `" + U + "` of type " + ("`" + z + "` supplied to `" + _ + "`, expected an object."));
        for (var W in M)
          if (r(M, W)) {
            var Y = v(M, W, _, B, U + "." + W, n);
            if (Y instanceof Error)
              return Y;
          }
        return null;
      }
      return y(O);
    }
    function V(v) {
      if (!Array.isArray(v))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var O = 0; O < v.length; O++) {
        var D = v[O];
        if (typeof D != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + re(D) + " at index " + O + "."
          ), s;
      }
      function j(_, B, U, M, z) {
        for (var W = [], Y = 0; Y < v.length; Y++) {
          var he = v[Y], C = he(_, B, U, M, z, n);
          if (C == null)
            return null;
          C.data && r(C.data, "expectedType") && W.push(C.data.expectedType);
        }
        var se = W.length > 0 ? ", expected one of type [" + W.join(", ") + "]" : "";
        return new w("Invalid " + M + " `" + z + "` supplied to " + ("`" + U + "`" + se + "."));
      }
      return y(j);
    }
    function J() {
      function v(O, D, j, _, B) {
        return te(O[D]) ? null : new w("Invalid " + _ + " `" + B + "` supplied to " + ("`" + j + "`, expected a ReactNode."));
      }
      return y(v);
    }
    function q(v, O, D, j, _) {
      return new w(
        (v || "React class") + ": " + O + " type `" + D + "." + j + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + _ + "`."
      );
    }
    function ee(v) {
      function O(D, j, _, B, U) {
        var M = D[j], z = ie(M);
        if (z !== "object")
          return new w("Invalid " + B + " `" + U + "` of type `" + z + "` " + ("supplied to `" + _ + "`, expected `object`."));
        for (var W in v) {
          var Y = v[W];
          if (typeof Y != "function")
            return q(_, B, U, W, K(Y));
          var he = Y(M, W, _, B, U + "." + W, n);
          if (he)
            return he;
        }
        return null;
      }
      return y(O);
    }
    function pe(v) {
      function O(D, j, _, B, U) {
        var M = D[j], z = ie(M);
        if (z !== "object")
          return new w("Invalid " + B + " `" + U + "` of type `" + z + "` " + ("supplied to `" + _ + "`, expected `object`."));
        var W = e({}, D[j], v);
        for (var Y in W) {
          var he = v[Y];
          if (r(v, Y) && typeof he != "function")
            return q(_, B, U, Y, K(he));
          if (!he)
            return new w(
              "Invalid " + B + " `" + U + "` key `" + Y + "` supplied to `" + _ + "`.\nBad object: " + JSON.stringify(D[j], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(v), null, "  ")
            );
          var C = he(M, Y, _, B, U + "." + Y, n);
          if (C)
            return C;
        }
        return null;
      }
      return y(O);
    }
    function te(v) {
      switch (typeof v) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !v;
        case "object":
          if (Array.isArray(v))
            return v.every(te);
          if (v === null || o(v))
            return !0;
          var O = h(v);
          if (O) {
            var D = O.call(v), j;
            if (O !== v.entries) {
              for (; !(j = D.next()).done; )
                if (!te(j.value))
                  return !1;
            } else
              for (; !(j = D.next()).done; ) {
                var _ = j.value;
                if (_ && !te(_[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function oe(v, O) {
      return v === "symbol" ? !0 : O ? O["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && O instanceof Symbol : !1;
    }
    function ie(v) {
      var O = typeof v;
      return Array.isArray(v) ? "array" : v instanceof RegExp ? "object" : oe(O, v) ? "symbol" : O;
    }
    function K(v) {
      if (typeof v > "u" || v === null)
        return "" + v;
      var O = ie(v);
      if (O === "object") {
        if (v instanceof Date)
          return "date";
        if (v instanceof RegExp)
          return "regexp";
      }
      return O;
    }
    function re(v) {
      var O = K(v);
      switch (O) {
        case "array":
        case "object":
          return "an " + O;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + O;
        default:
          return O;
      }
    }
    function de(v) {
      return !v.constructor || !v.constructor.name ? d : v.constructor.name;
    }
    return m.checkPropTypes = a, m.resetWarningCache = a.resetWarningCache, m.PropTypes = m, m;
  }, qt;
}
var Bt, qn;
function Wi() {
  if (qn) return Bt;
  qn = 1;
  var t = /* @__PURE__ */ gn();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, Bt = function() {
    function r(s, o, u, c, l, h) {
      if (h !== t) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return i.PropTypes = i, i;
  }, Bt;
}
var Bn;
function Yi() {
  if (Bn) return gt.exports;
  if (Bn = 1, process.env.NODE_ENV !== "production") {
    var t = jr(), e = !0;
    gt.exports = /* @__PURE__ */ Ui()(t.isElement, e);
  } else
    gt.exports = /* @__PURE__ */ Wi()();
  return gt.exports;
}
var Vi = /* @__PURE__ */ Yi();
const F = /* @__PURE__ */ Or(Vi);
function zi(t, e) {
  return t.classList ? !!e && t.classList.contains(e) : (" " + (t.className.baseVal || t.className) + " ").indexOf(" " + e + " ") !== -1;
}
function qi(t, e) {
  t.classList ? t.classList.add(e) : zi(t, e) || (typeof t.className == "string" ? t.className = t.className + " " + e : t.setAttribute("class", (t.className && t.className.baseVal || "") + " " + e));
}
function Hn(t, e) {
  return t.replace(new RegExp("(^|\\s)" + e + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function Bi(t, e) {
  t.classList ? t.classList.remove(e) : typeof t.className == "string" ? t.className = Hn(t.className, e) : t.setAttribute("class", Hn(t.className && t.className.baseVal || "", e));
}
const Kn = {
  disabled: !1
};
var Hi = process.env.NODE_ENV !== "production" ? F.oneOfType([F.number, F.shape({
  enter: F.number,
  exit: F.number,
  appear: F.number
}).isRequired]) : null, Ki = process.env.NODE_ENV !== "production" ? F.oneOfType([F.string, F.shape({
  enter: F.string,
  exit: F.string,
  active: F.string
}), F.shape({
  enter: F.string,
  enterDone: F.string,
  enterActive: F.string,
  exit: F.string,
  exitDone: F.string,
  exitActive: F.string
})]) : null;
const Fr = Ae.createContext(null);
var Ur = function(e) {
  return e.scrollTop;
}, at = "unmounted", Ie = "exited", je = "entering", Je = "entered", nn = "exiting", ke = /* @__PURE__ */ function(t) {
  Ir(e, t);
  function e(r, a) {
    var i;
    i = t.call(this, r, a) || this;
    var s = a, o = s && !s.isMounting ? r.enter : r.appear, u;
    return i.appearStatus = null, r.in ? o ? (u = Ie, i.appearStatus = je) : u = Je : r.unmountOnExit || r.mountOnEnter ? u = at : u = Ie, i.state = {
      status: u
    }, i.nextCallback = null, i;
  }
  e.getDerivedStateFromProps = function(a, i) {
    var s = a.in;
    return s && i.status === at ? {
      status: Ie
    } : null;
  };
  var n = e.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(a) {
    var i = null;
    if (a !== this.props) {
      var s = this.state.status;
      this.props.in ? s !== je && s !== Je && (i = je) : (s === je || s === Je) && (i = nn);
    }
    this.updateStatus(!1, i);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var a = this.props.timeout, i, s, o;
    return i = s = o = a, a != null && typeof a != "number" && (i = a.exit, s = a.enter, o = a.appear !== void 0 ? a.appear : s), {
      exit: i,
      enter: s,
      appear: o
    };
  }, n.updateStatus = function(a, i) {
    if (a === void 0 && (a = !1), i !== null)
      if (this.cancelNextCallback(), i === je) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var s = this.props.nodeRef ? this.props.nodeRef.current : ht.findDOMNode(this);
          s && Ur(s);
        }
        this.performEnter(a);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === Ie && this.setState({
      status: at
    });
  }, n.performEnter = function(a) {
    var i = this, s = this.props.enter, o = this.context ? this.context.isMounting : a, u = this.props.nodeRef ? [o] : [ht.findDOMNode(this), o], c = u[0], l = u[1], h = this.getTimeouts(), d = o ? h.appear : h.enter;
    if (!a && !s || Kn.disabled) {
      this.safeSetState({
        status: Je
      }, function() {
        i.props.onEntered(c);
      });
      return;
    }
    this.props.onEnter(c, l), this.safeSetState({
      status: je
    }, function() {
      i.props.onEntering(c, l), i.onTransitionEnd(d, function() {
        i.safeSetState({
          status: Je
        }, function() {
          i.props.onEntered(c, l);
        });
      });
    });
  }, n.performExit = function() {
    var a = this, i = this.props.exit, s = this.getTimeouts(), o = this.props.nodeRef ? void 0 : ht.findDOMNode(this);
    if (!i || Kn.disabled) {
      this.safeSetState({
        status: Ie
      }, function() {
        a.props.onExited(o);
      });
      return;
    }
    this.props.onExit(o), this.safeSetState({
      status: nn
    }, function() {
      a.props.onExiting(o), a.onTransitionEnd(s.exit, function() {
        a.safeSetState({
          status: Ie
        }, function() {
          a.props.onExited(o);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(a, i) {
    i = this.setNextCallback(i), this.setState(a, i);
  }, n.setNextCallback = function(a) {
    var i = this, s = !0;
    return this.nextCallback = function(o) {
      s && (s = !1, i.nextCallback = null, a(o));
    }, this.nextCallback.cancel = function() {
      s = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(a, i) {
    this.setNextCallback(i);
    var s = this.props.nodeRef ? this.props.nodeRef.current : ht.findDOMNode(this), o = a == null && !this.props.addEndListener;
    if (!s || o) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var u = this.props.nodeRef ? [this.nextCallback] : [s, this.nextCallback], c = u[0], l = u[1];
      this.props.addEndListener(c, l);
    }
    a != null && setTimeout(this.nextCallback, a);
  }, n.render = function() {
    var a = this.state.status;
    if (a === at)
      return null;
    var i = this.props, s = i.children;
    i.in, i.mountOnEnter, i.unmountOnExit, i.appear, i.enter, i.exit, i.timeout, i.addEndListener, i.onEnter, i.onEntering, i.onEntered, i.onExit, i.onExiting, i.onExited, i.nodeRef;
    var o = _r(i, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ Ae.createElement(Fr.Provider, {
        value: null
      }, typeof s == "function" ? s(a, o) : Ae.cloneElement(Ae.Children.only(s), o))
    );
  }, e;
}(Ae.Component);
ke.contextType = Fr;
ke.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: F.shape({
    current: typeof Element > "u" ? F.any : function(t, e, n, r, a, i) {
      var s = t[e];
      return F.instanceOf(s && "ownerDocument" in s ? s.ownerDocument.defaultView.Element : Element)(t, e, n, r, a, i);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: F.oneOfType([F.func.isRequired, F.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: F.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: F.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: F.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: F.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: F.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: F.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(e) {
    var n = Hi;
    e.addEndListener || (n = n.isRequired);
    for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
      a[i - 1] = arguments[i];
    return n.apply(void 0, [e].concat(a));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: F.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: F.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: F.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: F.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: F.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: F.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: F.func
} : {};
function qe() {
}
ke.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: qe,
  onEntering: qe,
  onEntered: qe,
  onExit: qe,
  onExiting: qe,
  onExited: qe
};
ke.UNMOUNTED = at;
ke.EXITED = Ie;
ke.ENTERING = je;
ke.ENTERED = Je;
ke.EXITING = nn;
var Gi = function(e, n) {
  return e && n && n.split(" ").forEach(function(r) {
    return qi(e, r);
  });
}, Ht = function(e, n) {
  return e && n && n.split(" ").forEach(function(r) {
    return Bi(e, r);
  });
}, mn = /* @__PURE__ */ function(t) {
  Ir(e, t);
  function e() {
    for (var r, a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(i)) || this, r.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, r.onEnter = function(o, u) {
      var c = r.resolveArguments(o, u), l = c[0], h = c[1];
      r.removeClasses(l, "exit"), r.addClass(l, h ? "appear" : "enter", "base"), r.props.onEnter && r.props.onEnter(o, u);
    }, r.onEntering = function(o, u) {
      var c = r.resolveArguments(o, u), l = c[0], h = c[1], d = h ? "appear" : "enter";
      r.addClass(l, d, "active"), r.props.onEntering && r.props.onEntering(o, u);
    }, r.onEntered = function(o, u) {
      var c = r.resolveArguments(o, u), l = c[0], h = c[1], d = h ? "appear" : "enter";
      r.removeClasses(l, d), r.addClass(l, d, "done"), r.props.onEntered && r.props.onEntered(o, u);
    }, r.onExit = function(o) {
      var u = r.resolveArguments(o), c = u[0];
      r.removeClasses(c, "appear"), r.removeClasses(c, "enter"), r.addClass(c, "exit", "base"), r.props.onExit && r.props.onExit(o);
    }, r.onExiting = function(o) {
      var u = r.resolveArguments(o), c = u[0];
      r.addClass(c, "exit", "active"), r.props.onExiting && r.props.onExiting(o);
    }, r.onExited = function(o) {
      var u = r.resolveArguments(o), c = u[0];
      r.removeClasses(c, "exit"), r.addClass(c, "exit", "done"), r.props.onExited && r.props.onExited(o);
    }, r.resolveArguments = function(o, u) {
      return r.props.nodeRef ? [r.props.nodeRef.current, o] : [o, u];
    }, r.getClassNames = function(o) {
      var u = r.props.classNames, c = typeof u == "string", l = c && u ? u + "-" : "", h = c ? "" + l + o : u[o], d = c ? h + "-active" : u[o + "Active"], m = c ? h + "-done" : u[o + "Done"];
      return {
        baseClassName: h,
        activeClassName: d,
        doneClassName: m
      };
    }, r;
  }
  var n = e.prototype;
  return n.addClass = function(a, i, s) {
    var o = this.getClassNames(i)[s + "ClassName"], u = this.getClassNames("enter"), c = u.doneClassName;
    i === "appear" && s === "done" && c && (o += " " + c), s === "active" && a && Ur(a), o && (this.appliedClasses[i][s] = o, Gi(a, o));
  }, n.removeClasses = function(a, i) {
    var s = this.appliedClasses[i], o = s.base, u = s.active, c = s.done;
    this.appliedClasses[i] = {}, o && Ht(a, o), u && Ht(a, u), c && Ht(a, c);
  }, n.render = function() {
    var a = this.props;
    a.classNames;
    var i = _r(a, ["classNames"]);
    return /* @__PURE__ */ Ae.createElement(ke, Et({}, i, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, e;
}(Ae.Component);
mn.defaultProps = {
  classNames: ""
};
mn.propTypes = process.env.NODE_ENV !== "production" ? Et({}, ke.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: Ki,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: F.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: F.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: F.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: F.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: F.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: F.func
}) : {};
const Ji = Se(ln)`
  position: relative;
  padding: 4px 12px !important;
  border-radius: 20px;
  min-width: 74px !important;
  height: 32px !important;
  overflow: hidden;
  color: ${({ theme: t }) => t.dec.color.primary.active.fg.norm};
`, Qi = Se(mn)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 0;
  background: ${({ theme: t }) => t.dec.color.primary.default.sh.brand};
  transition: width 1s linear;
`, Xi = ({ step: t, error: e, onClick: n, ...r }) => {
  const a = [
    { progress: 12.5, duration: 1 },
    { progress: 75, duration: 7 },
    { progress: 87.5, duration: 1 },
    { progress: 100, duration: 1 },
    { progress: 100, duration: 1 }
  ], [i, s] = Te(0), [o, u] = Te(1), [c, l] = Te(!0), h = cn(null);
  return we(() => {
    setTimeout(() => {
      s(a[t].progress), u(a[t].duration);
    });
  }, [t]), we(() => {
    const d = (m) => {
      var g;
      (g = h.current) != null && g.contains(m.target) || l(!1);
    };
    return document.addEventListener("click", d, !0), () => {
      document.removeEventListener("click", d, !0);
    };
  }, []), /* @__PURE__ */ N.jsx(
    hn,
    {
      type: "default",
      isVisible: c ? !0 : void 0,
      content: /* @__PURE__ */ N.jsx(Ii, { step: t, error: e, ...r }),
      status: "Info",
      zIndex: !0,
      className: "tag-refresh-tooltip",
      children: /* @__PURE__ */ N.jsx(
        Ji,
        {
          variant: "outlined",
          label: /* @__PURE__ */ N.jsxs("div", { children: [
            /* @__PURE__ */ N.jsx(
              Qi,
              {
                in: !0,
                appear: !0,
                unmountOnExit: !0,
                style: { width: `${i}%`, transitionDuration: `${o}s` },
                timeout: 250,
                children: /* @__PURE__ */ N.jsx("span", {})
              }
            ),
            /* @__PURE__ */ N.jsx(Sr, {})
          ] }),
          "data-testid": "progress-button",
          ref: h,
          onClick: n
        }
      )
    }
  );
}, Zi = ({
  status: t = $.idle,
  version: e,
  lastUpdate: n,
  frameworkSettingsUrl: r,
  progress: a,
  notification: i,
  onClick: s
}) => /* @__PURE__ */ N.jsx("div", { "data-testid": "tag-refresh-component", children: a ? /* @__PURE__ */ N.jsx(Xi, { onClick: s, ...a }) : i ? /* @__PURE__ */ N.jsx(Ni, { ...i, children: /* @__PURE__ */ N.jsx(
  Wt,
  {
    status: t,
    onClick: () => {
      i.hideNotification(), s();
    }
  }
) }) : t === $.pending ? /* @__PURE__ */ N.jsx(Wt, { status: t, onClick: s }) : /* @__PURE__ */ N.jsx(
  Pi,
  {
    status: t,
    version: e,
    lastUpdate: n,
    frameworkSettingsUrl: r,
    children: /* @__PURE__ */ N.jsx(Wt, { status: t, onClick: s })
  }
) }), es = ({
  clearing: t,
  compilationStatus: e,
  compilationError: n,
  pack: r,
  showCheckMark: a,
  status: i,
  fetching: s
}) => t ? $.pending : e === ue.Error ? St(n) ? $.user_error : $.error : n && JSON.parse(n).length ? $.warning : r === Da.Inactive ? $.inactive : a === !0 && i === Oe.success ? $.success : a === !0 && i === Oe.idle || [Oe.idle, Oe.success, void 0].includes(i) || s ? $.idle : i === Oe.empty ? $.empty : i === Oe.error ? $.api_error : $.error, Wr = 6048e5, ts = 864e5, Gn = Symbol.for("constructDateFrom");
function Le(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && Gn in t ? t[Gn](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function Ee(t, e) {
  return Le(e || t, t);
}
let ns = {};
function Nt() {
  return ns;
}
function ct(t, e) {
  var o, u, c, l;
  const n = Nt(), r = (e == null ? void 0 : e.weekStartsOn) ?? ((u = (o = e == null ? void 0 : e.locale) == null ? void 0 : o.options) == null ? void 0 : u.weekStartsOn) ?? n.weekStartsOn ?? ((l = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : l.weekStartsOn) ?? 0, a = Ee(t, e == null ? void 0 : e.in), i = a.getDay(), s = (i < r ? 7 : 0) + i - r;
  return a.setDate(a.getDate() - s), a.setHours(0, 0, 0, 0), a;
}
function Ot(t, e) {
  return ct(t, { ...e, weekStartsOn: 1 });
}
function Yr(t, e) {
  const n = Ee(t, e == null ? void 0 : e.in), r = n.getFullYear(), a = Le(n, 0);
  a.setFullYear(r + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const i = Ot(a), s = Le(n, 0);
  s.setFullYear(r, 0, 4), s.setHours(0, 0, 0, 0);
  const o = Ot(s);
  return n.getTime() >= i.getTime() ? r + 1 : n.getTime() >= o.getTime() ? r : r - 1;
}
function Jn(t) {
  const e = Ee(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function rs(t, ...e) {
  const n = Le.bind(
    null,
    e.find((r) => typeof r == "object")
  );
  return e.map(n);
}
function Qn(t, e) {
  const n = Ee(t, e == null ? void 0 : e.in);
  return n.setHours(0, 0, 0, 0), n;
}
function as(t, e, n) {
  const [r, a] = rs(
    n == null ? void 0 : n.in,
    t,
    e
  ), i = Qn(r), s = Qn(a), o = +i - Jn(i), u = +s - Jn(s);
  return Math.round((o - u) / ts);
}
function is(t, e) {
  const n = Yr(t, e), r = Le(t, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Ot(r);
}
function ss(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function os(t) {
  return !(!ss(t) && typeof t != "number" || isNaN(+Ee(t)));
}
function us(t, e) {
  const n = Ee(t, e == null ? void 0 : e.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const cs = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, ls = (t, e, n) => {
  let r;
  const a = cs[t];
  return typeof a == "string" ? r = a : e === 1 ? r = a.one : r = a.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function Kt(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const fs = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, ds = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, hs = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ps = {
  date: Kt({
    formats: fs,
    defaultWidth: "full"
  }),
  time: Kt({
    formats: ds,
    defaultWidth: "full"
  }),
  dateTime: Kt({
    formats: hs,
    defaultWidth: "full"
  })
}, gs = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, ms = (t, e, n, r) => gs[t];
function Xe(t) {
  return (e, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let a;
    if (r === "formatting" && t.formattingValues) {
      const s = t.defaultFormattingWidth || t.defaultWidth, o = n != null && n.width ? String(n.width) : s;
      a = t.formattingValues[o] || t.formattingValues[s];
    } else {
      const s = t.defaultWidth, o = n != null && n.width ? String(n.width) : t.defaultWidth;
      a = t.values[o] || t.values[s];
    }
    const i = t.argumentCallback ? t.argumentCallback(e) : e;
    return a[i];
  };
}
const ys = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, vs = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, bs = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, ws = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, xs = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Ts = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Ss = (t, e) => {
  const n = Number(t), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, Es = {
  ordinalNumber: Ss,
  era: Xe({
    values: ys,
    defaultWidth: "wide"
  }),
  quarter: Xe({
    values: vs,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: Xe({
    values: bs,
    defaultWidth: "wide"
  }),
  day: Xe({
    values: ws,
    defaultWidth: "wide"
  }),
  dayPeriod: Xe({
    values: xs,
    defaultWidth: "wide",
    formattingValues: Ts,
    defaultFormattingWidth: "wide"
  })
};
function Ze(t) {
  return (e, n = {}) => {
    const r = n.width, a = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], i = e.match(a);
    if (!i)
      return null;
    const s = i[0], o = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], u = Array.isArray(o) ? Cs(o, (h) => h.test(s)) : (
      // [TODO] -- I challenge you to fix the type
      Os(o, (h) => h.test(s))
    );
    let c;
    c = t.valueCallback ? t.valueCallback(u) : u, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const l = e.slice(s.length);
    return { value: c, rest: l };
  };
}
function Os(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function Cs(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function Ps(t) {
  return (e, n = {}) => {
    const r = e.match(t.matchPattern);
    if (!r) return null;
    const a = r[0], i = e.match(t.parsePattern);
    if (!i) return null;
    let s = t.valueCallback ? t.valueCallback(i[0]) : i[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const o = e.slice(a.length);
    return { value: s, rest: o };
  };
}
const ks = /^(\d+)(th|st|nd|rd)?/i, Rs = /\d+/i, Ns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, As = {
  any: [/^b/i, /^(a|c)/i]
}, $s = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Ls = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ds = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, _s = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Is = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, js = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Ms = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Fs = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Us = {
  ordinalNumber: Ps({
    matchPattern: ks,
    parsePattern: Rs,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: Ze({
    matchPatterns: Ns,
    defaultMatchWidth: "wide",
    parsePatterns: As,
    defaultParseWidth: "any"
  }),
  quarter: Ze({
    matchPatterns: $s,
    defaultMatchWidth: "wide",
    parsePatterns: Ls,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: Ze({
    matchPatterns: Ds,
    defaultMatchWidth: "wide",
    parsePatterns: _s,
    defaultParseWidth: "any"
  }),
  day: Ze({
    matchPatterns: Is,
    defaultMatchWidth: "wide",
    parsePatterns: js,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ze({
    matchPatterns: Ms,
    defaultMatchWidth: "any",
    parsePatterns: Fs,
    defaultParseWidth: "any"
  })
}, Ws = {
  code: "en-US",
  formatDistance: ls,
  formatLong: ps,
  formatRelative: ms,
  localize: Es,
  match: Us,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Ys(t, e) {
  const n = Ee(t, e == null ? void 0 : e.in);
  return as(n, us(n)) + 1;
}
function Vs(t, e) {
  const n = Ee(t, e == null ? void 0 : e.in), r = +Ot(n) - +is(n);
  return Math.round(r / Wr) + 1;
}
function Vr(t, e) {
  var l, h, d, m;
  const n = Ee(t, e == null ? void 0 : e.in), r = n.getFullYear(), a = Nt(), i = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((h = (l = e == null ? void 0 : e.locale) == null ? void 0 : l.options) == null ? void 0 : h.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((m = (d = a.locale) == null ? void 0 : d.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, s = Le((e == null ? void 0 : e.in) || t, 0);
  s.setFullYear(r + 1, 0, i), s.setHours(0, 0, 0, 0);
  const o = ct(s, e), u = Le((e == null ? void 0 : e.in) || t, 0);
  u.setFullYear(r, 0, i), u.setHours(0, 0, 0, 0);
  const c = ct(u, e);
  return +n >= +o ? r + 1 : +n >= +c ? r : r - 1;
}
function zs(t, e) {
  var o, u, c, l;
  const n = Nt(), r = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((u = (o = e == null ? void 0 : e.locale) == null ? void 0 : o.options) == null ? void 0 : u.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((l = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : l.firstWeekContainsDate) ?? 1, a = Vr(t, e), i = Le((e == null ? void 0 : e.in) || t, 0);
  return i.setFullYear(a, 0, r), i.setHours(0, 0, 0, 0), ct(i, e);
}
function qs(t, e) {
  const n = Ee(t, e == null ? void 0 : e.in), r = +ct(n, e) - +zs(n, e);
  return Math.round(r / Wr) + 1;
}
function Z(t, e) {
  const n = t < 0 ? "-" : "", r = Math.abs(t).toString().padStart(e, "0");
  return n + r;
}
const $e = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), r = n > 0 ? n : 1 - n;
    return Z(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : Z(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return Z(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return Z(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return Z(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return Z(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return Z(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, r = t.getMilliseconds(), a = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Z(a, e.length);
  }
}, Be = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Xn = {
  // Era
  G: function(t, e, n) {
    const r = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const r = t.getFullYear(), a = r > 0 ? r : 1 - r;
      return n.ordinalNumber(a, { unit: "year" });
    }
    return $e.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, r) {
    const a = Vr(t, r), i = a > 0 ? a : 1 - a;
    if (e === "YY") {
      const s = i % 100;
      return Z(s, 2);
    }
    return e === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : Z(i, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = Yr(t);
    return Z(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return Z(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return Z(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return Z(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return $e.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return Z(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, r) {
    const a = qs(t, r);
    return e === "wo" ? n.ordinalNumber(a, { unit: "week" }) : Z(a, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const r = Vs(t);
    return e === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Z(r, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : $e.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const r = Ys(t);
    return e === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Z(r, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const r = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, r) {
    const a = t.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return Z(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, r) {
    const a = t.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return Z(i, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const r = t.getDay(), a = r === 0 ? 7 : r;
    switch (e) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return Z(a, e.length);
      // 2nd
      case "io":
        return n.ordinalNumber(a, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const a = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const r = t.getHours();
    let a;
    switch (r === 12 ? a = Be.noon : r === 0 ? a = Be.midnight : a = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const r = t.getHours();
    let a;
    switch (r >= 17 ? a = Be.evening : r >= 12 ? a = Be.afternoon : r >= 4 ? a = Be.morning : a = Be.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let r = t.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return $e.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : $e.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const r = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Z(r, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let r = t.getHours();
    return r === 0 && (r = 24), e === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Z(r, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : $e.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : $e.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return $e.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const r = t.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return er(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Me(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Me(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return er(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Me(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Me(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Zn(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Me(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Zn(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Me(r, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const r = Math.trunc(+t / 1e3);
    return Z(r, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return Z(+t, e.length);
  }
};
function Zn(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), a = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(a) : n + String(a) + e + Z(i, 2);
}
function er(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + Z(Math.abs(t) / 60, 2) : Me(t, e);
}
function Me(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), a = Z(Math.trunc(r / 60), 2), i = Z(r % 60, 2);
  return n + a + e + i;
}
const tr = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, zr = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, Bs = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], r = n[1], a = n[2];
  if (!a)
    return tr(t, e);
  let i;
  switch (r) {
    case "P":
      i = e.dateTime({ width: "short" });
      break;
    case "PP":
      i = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = e.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", tr(r, e)).replace("{{time}}", zr(a, e));
}, Hs = {
  p: zr,
  P: Bs
}, Ks = /^D+$/, Gs = /^Y+$/, Js = ["D", "DD", "YY", "YYYY"];
function Qs(t) {
  return Ks.test(t);
}
function Xs(t) {
  return Gs.test(t);
}
function Zs(t, e, n) {
  const r = eo(t, e, n);
  if (console.warn(r), Js.includes(t)) throw new RangeError(r);
}
function eo(t, e, n) {
  const r = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const to = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, no = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ro = /^'([^]*?)'?$/, ao = /''/g, io = /[a-zA-Z]/;
function so(t, e, n) {
  var l, h, d, m, g, w, y, P;
  const r = Nt(), a = (n == null ? void 0 : n.locale) ?? r.locale ?? Ws, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((h = (l = n == null ? void 0 : n.locale) == null ? void 0 : l.options) == null ? void 0 : h.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((m = (d = r.locale) == null ? void 0 : d.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, s = (n == null ? void 0 : n.weekStartsOn) ?? ((w = (g = n == null ? void 0 : n.locale) == null ? void 0 : g.options) == null ? void 0 : w.weekStartsOn) ?? r.weekStartsOn ?? ((P = (y = r.locale) == null ? void 0 : y.options) == null ? void 0 : P.weekStartsOn) ?? 0, o = Ee(t, n == null ? void 0 : n.in);
  if (!os(o))
    throw new RangeError("Invalid time value");
  let u = e.match(no).map((E) => {
    const x = E[0];
    if (x === "p" || x === "P") {
      const T = Hs[x];
      return T(E, a.formatLong);
    }
    return E;
  }).join("").match(to).map((E) => {
    if (E === "''")
      return { isToken: !1, value: "'" };
    const x = E[0];
    if (x === "'")
      return { isToken: !1, value: oo(E) };
    if (Xn[x])
      return { isToken: !0, value: E };
    if (x.match(io))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + x + "`"
      );
    return { isToken: !1, value: E };
  });
  a.localize.preprocessor && (u = a.localize.preprocessor(o, u));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: s,
    locale: a
  };
  return u.map((E) => {
    if (!E.isToken) return E.value;
    const x = E.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && Xs(x) || !(n != null && n.useAdditionalDayOfYearTokens) && Qs(x)) && Zs(x, e, String(t));
    const T = Xn[x[0]];
    return T(o, x, a.localize, c);
  }).join("");
}
function oo(t) {
  const e = t.match(ro);
  return e ? e[1].replace(ao, "'") : t;
}
const Gt = {}, it = {};
function st(t, e) {
  try {
    const r = (Gt[t] || (Gt[t] = new Intl.DateTimeFormat("en-GB", {
      timeZone: t,
      hour: "numeric",
      timeZoneName: "longOffset"
    }).format))(e).split("GMT")[1] || "";
    return r in it ? it[r] : nr(r, r.split(":"));
  } catch {
    if (t in it) return it[t];
    const n = t == null ? void 0 : t.match(uo);
    return n ? nr(t, n.slice(1)) : NaN;
  }
}
const uo = /([+-]\d\d):?(\d\d)?/;
function nr(t, e) {
  const n = +e[0], r = +(e[1] || 0);
  return it[t] = n > 0 ? n * 60 + r : n * 60 - r;
}
class Ce extends Date {
  //#region static
  constructor(...e) {
    super(), e.length > 1 && typeof e[e.length - 1] == "string" && (this.timeZone = e.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(st(this.timeZone, this)) ? this.setTime(NaN) : e.length ? typeof e[0] == "number" && (e.length === 1 || e.length === 2 && typeof e[1] != "number") ? this.setTime(e[0]) : typeof e[0] == "string" ? this.setTime(+new Date(e[0])) : e[0] instanceof Date ? this.setTime(+e[0]) : (this.setTime(+new Date(...e)), qr(this), rn(this)) : this.setTime(Date.now());
  }
  static tz(e, ...n) {
    return n.length ? new Ce(...n, e) : new Ce(Date.now(), e);
  }
  //#endregion
  //#region time zone
  withTimeZone(e) {
    return new Ce(+this, e);
  }
  getTimezoneOffset() {
    return -st(this.timeZone, this);
  }
  //#endregion
  //#region time
  setTime(e) {
    return Date.prototype.setTime.apply(this, arguments), rn(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](e) {
    return new Ce(+new Date(e), this.timeZone);
  }
  //#endregion
}
const rr = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((t) => {
  if (!rr.test(t)) return;
  const e = t.replace(rr, "$1UTC");
  Ce.prototype[e] && (t.startsWith("get") ? Ce.prototype[t] = function() {
    return this.internal[e]();
  } : (Ce.prototype[t] = function() {
    return Date.prototype[e].apply(this.internal, arguments), co(this), +this;
  }, Ce.prototype[e] = function() {
    return Date.prototype[e].apply(this, arguments), rn(this), +this;
  }));
});
function rn(t) {
  t.internal.setTime(+t), t.internal.setUTCMinutes(t.internal.getUTCMinutes() - t.getTimezoneOffset());
}
function co(t) {
  Date.prototype.setFullYear.call(t, t.internal.getUTCFullYear(), t.internal.getUTCMonth(), t.internal.getUTCDate()), Date.prototype.setHours.call(t, t.internal.getUTCHours(), t.internal.getUTCMinutes(), t.internal.getUTCSeconds(), t.internal.getUTCMilliseconds()), qr(t);
}
function qr(t) {
  const e = st(t.timeZone, t), n = /* @__PURE__ */ new Date(+t);
  n.setUTCHours(n.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset(), a = -(/* @__PURE__ */ new Date(+n)).getTimezoneOffset(), i = r - a, s = Date.prototype.getHours.apply(t) !== t.internal.getUTCHours();
  i && s && t.internal.setUTCMinutes(t.internal.getUTCMinutes() + i);
  const o = r - e;
  o && Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + o);
  const u = st(t.timeZone, t), l = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset() - u, h = u !== e, d = l - o;
  if (h && d) {
    Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + d);
    const m = st(t.timeZone, t), g = u - m;
    g && (t.internal.setUTCMinutes(t.internal.getUTCMinutes() + g), Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + g));
  }
}
const an = ({ date: t, timezone: e, locale: n }) => {
  const r = /* @__PURE__ */ new Date(`${t}Z`);
  return so(new Ce(r, e), "P - pp - 'UTC' XXX", { locale: n });
}, me = (t, e) => (n) => t(e(n)), yt = (t, e, n = 2e3, r = 5e4, a = () => !1) => {
  let i = null;
  const s = (u) => new Promise((c) => {
    a() || setTimeout(() => c(), u);
  }), o = async () => {
    i && await s(n), i = i || +/* @__PURE__ */ new Date();
    const u = await t(), c = +/* @__PURE__ */ new Date() - i;
    return e(u) || c > r ? Promise.resolve(u) : o();
  };
  return a() ? () => Promise.reject(new Error()) : o;
};
class lo {
  constructor({ hostname: e } = {}) {
    this.client = _a({
      hosts: {
        default: e ?? window.API_HOST
      }
    });
  }
  getTagState(e) {
    return this.client.settings.fetchLastScriptUpdate({ accountId: e }).then(({ last_update: n, is_script_empty: r, status: a }) => ({
      lastDate: n,
      isEmpty: Number.isInteger(r) ? !!r : void 0,
      status: a
    }));
  }
  compileTag(e) {
    return this.client.settings.buildScript({ accountId: e });
  }
  clearTag(e) {
    return this.client.settings.clearScript({ accountId: e });
  }
  getTagCompilationStatus(e) {
    return this.client.v1.accounts.get({ accountId: e }).then(({ latest_tag_compilation: n }) => ({
      status: n.status,
      error: n.error,
      lastUpdateTimestamp: n.last_update_datetime.timestamp
    }));
  }
}
let Jt;
function fo(t) {
  return Jt || (Jt = new lo(t)), Jt;
}
const Br = "REQUEST_TAG_COMPILATION", ho = () => ({
  type: Br
}), Hr = "REQUEST_TAG_CLEAR", po = () => ({
  type: Hr
}), Kr = "REQUEST_COMPILATION_STOP", go = (t) => ({
  type: Kr,
  payload: {
    stop: t
  }
}), Gr = "SET_COMPILATION_STATE", mo = (t) => ({
  type: Gr,
  payload: t
}), Jr = "SET_IDLE", yo = () => ({
  type: Jr
}), Qr = "SET_COMPILATION_PROGRESS", vo = (t) => ({
  type: Qr,
  payload: {
    step: t
  }
}), Xr = "SET_COMPILATION_STATUS_UPDATE", bo = (t) => ({
  type: Xr,
  payload: t
}), Zr = "SET_COMPILATION_STATUS_UPDATE_FAILED", wo = () => ({
  type: Zr
}), ea = "SET_TAG_COMPILATION_STATE", xo = (t) => ({
  type: ea,
  payload: t
}), ta = "SET_TAG_COMPILATION_STATUS", To = (t) => ({
  type: ta,
  payload: {
    status: t
  }
}), na = "SET_TAG_COMPILATION_UPDATE", So = (t) => ({
  type: na,
  payload: t
}), Eo = (t, e) => {
  switch (e.type) {
    case Br:
      return { ...t, fetching: !0, progress: fe.request };
    case Hr:
      return { ...t, fetching: !0, clearing: !0 };
    case Kr:
      return { ...t, stop: e.payload.stop };
    case Gr:
      return { ...t, ...e.payload, fetching: !1, initialized: !0, clearing: !1 };
    case Jr:
      return { ...t, fetching: !1, clearing: !1 };
    case Qr:
      return { ...t, progress: e.payload.step };
    case Xr:
      if (!t.tagCompilation)
        throw new Error("can't update tag compilation status before setting compilation state");
      return e.payload.status ? {
        ...t,
        ...e.payload,
        progress: fe.publishment,
        fetching: !1,
        initialized: !0,
        clearing: !1,
        tagCompilation: {
          ...t.tagCompilation,
          status: ue.Deployed
        }
      } : {
        ...t,
        fetching: !1,
        status: Oe.error,
        tagCompilation: {
          ...t.tagCompilation,
          status: ue.Timeout
        }
      };
    case Zr:
      if (!t.tagCompilation)
        throw new Error("can't update tag compilation status before setting compilation state");
      return {
        ...t,
        fetching: !1,
        clearing: !1,
        tagCompilation: { ...t.tagCompilation, status: ue.Error }
      };
    case ea:
      return { ...t, tagCompilation: e.payload };
    case ta:
      if (!t.tagCompilation)
        throw new Error("can't update tag compilation status before setting compilation state");
      return { ...t, tagCompilation: { ...t.tagCompilation, status: e.payload.status } };
    case na:
      return [ue.Error, ue.Timeout].includes(e.payload.status) ? { ...t, fetching: !1, clearing: !1, tagCompilation: e.payload } : { ...t, progress: fe.server, tagCompilation: e.payload };
    default:
      return t;
  }
}, Oo = {
  clearing: !1,
  fetching: !1,
  initialized: !1
}, Co = ({ tagCompilation: t }) => {
  const [e, n] = Tr(Eo, { ...Oo, tagCompilation: t });
  return {
    state: e,
    actions: {
      requestTagCompilation: me(n, ho),
      requestTagClear: me(n, po),
      setCompilationState: me(n, mo),
      setIdle: me(n, yo),
      setCompilationProgress: me(n, vo),
      setCompilationStatusUpdate: me(n, bo),
      setCompilationStatusUpdateFailed: me(n, wo),
      requestCompilationStop: me(n, go),
      setTagCompilationState: me(n, xo),
      setTagCompilationStatus: me(n, To),
      setTagCompilationUpdate: me(n, So)
    }
  };
}, ra = "SHOW_SUCCESS_NOTIFICATION", Po = (t) => ({
  type: ra,
  payload: {
    type: ve.success,
    ...t
  }
}), aa = "SHOW_WARNING_NOTIFICATION", ko = (t) => ({
  type: aa,
  payload: {
    type: ve.warning,
    ...t
  }
}), ia = "SHOW_REMINDER_NOTIFICATION", Ro = (t) => ({
  type: ia,
  payload: {
    type: ve.reminder,
    ...t
  }
}), sa = "SHOW_FAIL_NOTIFICATION", sn = (t) => ({
  type: sa,
  payload: {
    type: ve.fail,
    ...t
  }
}), oa = "HIDE_NOTIFICATION", No = () => ({
  type: oa
}), Ao = (t, e) => {
  switch (e.type) {
    case ra:
    case aa:
    case ia:
    case sa:
      return { ...t || {}, ...e.payload, description: e.payload.description ?? void 0 };
    case oa:
      return null;
    default:
      return t;
  }
}, $o = () => {
  const [t, e] = Tr(Ao, null), [n, r] = Te(), a = {
    showSuccessNotification: me(e, Po),
    showWarningNotification: me(e, ko),
    showReminderNotification: me(e, Ro),
    showFailNotification: me(e, sn),
    hideNotification: me(e, No)
  };
  we(() => () => {
    n && clearTimeout(n);
  }, []);
  const i = (s) => ({ sticked: o, ...u }) => {
    if (!o) {
      const c = setTimeout(() => a.hideNotification(), 1e4);
      r(c);
    }
    s(u);
  };
  return {
    state: t,
    actions: {
      showSuccessNotification: i(a.showSuccessNotification),
      showWarningNotification: i(a.showWarningNotification),
      showReminderNotification: i(a.showReminderNotification),
      showFailNotification: i(a.showFailNotification),
      hideNotification: a.hideNotification
    }
  };
};
class et extends Error {
  constructor() {
    super("Account id is missing");
  }
}
const Lo = ({ accountId: t, tagCompilation: e, apiHostname: n, ...r }) => {
  const {
    state: a,
    actions: { showReminderNotification: i, ...s }
  } = $o(), { state: o, actions: u } = Co({ tagCompilation: e }), { reminder: c, failed: l, failedWithErrors: h, failed_info: d, succeeded: m } = pn(), g = fo({ hostname: n }), w = Ge(() => {
    if (!t) throw new et();
    return g.getTagState(t).then((T) => u.setCompilationState(T)), yt(
      () => g.getTagState(t),
      ({ isEmpty: T }) => T === !1,
      // wait for tag not empty
      5e3,
      2e4
    )().then((T) => (u.setCompilationState(T), T));
  }, [t]), y = Ge(async () => {
    if (!t) throw new et();
    try {
      let T = o.lastDate;
      const p = await yt(
        () => g.getTagState(t),
        ({ lastDate: S }) => (T || (T = S ?? (/* @__PURE__ */ new Date()).toISOString()), !!S && T !== S),
        2e3,
        12e4,
        () => !!o.stop
      )();
      return u.setCompilationStatusUpdate(p), p;
    } catch {
      u.setCompilationStatusUpdateFailed();
    }
  }, [t, o.stop, o.lastDate]), P = Ge(async () => {
    if (!t) throw new et();
    try {
      let T;
      const { error: p, status: S, lastUpdateTimestamp: A } = await yt(
        () => g.getTagCompilationStatus(t).then((V) => (T || (T = {
          error: "[]",
          status: ue.Pending,
          lastUpdateTimestamp: V.lastUpdateTimestamp
        }, u.setTagCompilationState(T), u.setCompilationProgress(fe.compilation)), V)),
        ({ status: V }) => [
          ue.Compiled,
          ue.Error,
          ue.Timeout,
          ue.Empty
        ].includes(V),
        2e3,
        12e4,
        () => !!o.stop
      )(), R = {
        error: p,
        lastUpdateTimestamp: A,
        status: S
      };
      return u.setTagCompilationUpdate(R), [ue.Error, ue.Timeout].includes(S) && u.setIdle(), R;
    } catch {
      u.setIdle();
    }
  }, [t, o.tagCompilation, o.stop]), E = Ge(
    async ({ listenOnly: T } = {}) => {
      var p, S;
      if (!t) throw new et();
      try {
        u.requestTagCompilation(), T || (u.requestCompilationStop(!0), await g.compileTag(t), u.requestCompilationStop(!1));
        let A = (p = o.tagCompilation) == null ? void 0 : p.status;
        if (!o.stop) {
          const V = await P();
          V && (A = V.status);
        }
        !o.stop && A && ![ue.Error, ue.Timeout].includes(A) && await y();
        const { status: R } = await g.getTagState(t);
        if (R !== Oe.success || A === ue.Error)
          throw new Error(
            `Tag compilation is not successful (${JSON.stringify({ status: R, compilationStatus: A })})`
          );
      } catch {
        s.showFailNotification({
          label: St((S = o.tagCompilation) == null ? void 0 : S.error) ? h(r.settingsUrl) : l,
          description: o.lastDate ? d(
            an({
              date: o.lastDate,
              locale: r.locale,
              timezone: r.timezone
            })
          ) : void 0,
          sticked: !0
        });
      }
    },
    [
      t,
      o.stop,
      o.tagCompilation,
      o.lastDate,
      r.locale,
      r.timezone,
      r.settingsUrl,
      l,
      d,
      P,
      y
    ]
  ), x = Ge(async () => {
    var T;
    if (!t) throw new et();
    u.requestTagClear();
    try {
      await g.clearTag(t);
      const p = await yt(
        () => g.getTagState(t),
        ({ isEmpty: A }) => A === !0
      )();
      u.setCompilationState(p);
      const S = p.lastDate ? an({
        date: p.lastDate,
        locale: r.locale,
        timezone: r.timezone
      }) : void 0;
      return s.showSuccessNotification({ label: m(S) }), p;
    } catch {
      u.setIdle(), s.showFailNotification({
        label: St((T = o.tagCompilation) == null ? void 0 : T.error) ? h(r.settingsUrl) : l,
        sticked: !0
      });
    }
  }, [t, m, l, r.locale, r.timezone, r.settingsUrl]);
  return {
    ...r,
    isButtonUsable: !!t,
    notification: a,
    ...s,
    compilation: o,
    ...u,
    fetchTagState: w,
    compileTag: E,
    clearTag: x,
    listenTagUpdates: y,
    showCompilationReminder: () => i({
      label: c
    })
  };
}, ua = xr({
  initialized: !1
}), Du = ({ children: t, ...e }) => {
  const n = Lo(e);
  return /* @__PURE__ */ N.jsx(ua.Provider, { value: n, children: t });
}, Do = () => {
  const t = un(ua);
  if ("initialized" in t && !t.initialized) throw new Error("Tag context is not initialized");
  return t;
}, I = (t) => typeof t == "string", tt = () => {
  let t, e;
  const n = new Promise((r, a) => {
    t = r, e = a;
  });
  return n.resolve = t, n.reject = e, n;
}, ar = (t) => t == null ? "" : "" + t, _o = (t, e, n) => {
  t.forEach((r) => {
    e[r] && (n[r] = e[r]);
  });
}, Io = /###/g, ir = (t) => t && t.indexOf("###") > -1 ? t.replace(Io, ".") : t, sr = (t) => !t || I(t), ot = (t, e, n) => {
  const r = I(e) ? e.split(".") : e;
  let a = 0;
  for (; a < r.length - 1; ) {
    if (sr(t)) return {};
    const i = ir(r[a]);
    !t[i] && n && (t[i] = new n()), Object.prototype.hasOwnProperty.call(t, i) ? t = t[i] : t = {}, ++a;
  }
  return sr(t) ? {} : {
    obj: t,
    k: ir(r[a])
  };
}, or = (t, e, n) => {
  const {
    obj: r,
    k: a
  } = ot(t, e, Object);
  if (r !== void 0 || e.length === 1) {
    r[a] = n;
    return;
  }
  let i = e[e.length - 1], s = e.slice(0, e.length - 1), o = ot(t, s, Object);
  for (; o.obj === void 0 && s.length; )
    i = `${s[s.length - 1]}.${i}`, s = s.slice(0, s.length - 1), o = ot(t, s, Object), o != null && o.obj && typeof o.obj[`${o.k}.${i}`] < "u" && (o.obj = void 0);
  o.obj[`${o.k}.${i}`] = n;
}, jo = (t, e, n, r) => {
  const {
    obj: a,
    k: i
  } = ot(t, e, Object);
  a[i] = a[i] || [], a[i].push(n);
}, Ct = (t, e) => {
  const {
    obj: n,
    k: r
  } = ot(t, e);
  if (n && Object.prototype.hasOwnProperty.call(n, r))
    return n[r];
}, Mo = (t, e, n) => {
  const r = Ct(t, n);
  return r !== void 0 ? r : Ct(e, n);
}, ca = (t, e, n) => {
  for (const r in e)
    r !== "__proto__" && r !== "constructor" && (r in t ? I(t[r]) || t[r] instanceof String || I(e[r]) || e[r] instanceof String ? n && (t[r] = e[r]) : ca(t[r], e[r], n) : t[r] = e[r]);
  return t;
}, He = (t) => t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var Fo = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const Uo = (t) => I(t) ? t.replace(/[&<>"'\/]/g, (e) => Fo[e]) : t;
class Wo {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const n = this.regExpMap.get(e);
    if (n !== void 0)
      return n;
    const r = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, r), this.regExpQueue.push(e), r;
  }
}
const Yo = [" ", ",", "?", "!", ";"], Vo = new Wo(20), zo = (t, e, n) => {
  e = e || "", n = n || "";
  const r = Yo.filter((s) => e.indexOf(s) < 0 && n.indexOf(s) < 0);
  if (r.length === 0) return !0;
  const a = Vo.getRegExp(`(${r.map((s) => s === "?" ? "\\?" : s).join("|")})`);
  let i = !a.test(t);
  if (!i) {
    const s = t.indexOf(n);
    s > 0 && !a.test(t.substring(0, s)) && (i = !0);
  }
  return i;
}, on = function(t, e) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!t) return;
  if (t[e])
    return Object.prototype.hasOwnProperty.call(t, e) ? t[e] : void 0;
  const r = e.split(n);
  let a = t;
  for (let i = 0; i < r.length; ) {
    if (!a || typeof a != "object")
      return;
    let s, o = "";
    for (let u = i; u < r.length; ++u)
      if (u !== i && (o += n), o += r[u], s = a[o], s !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof s) > -1 && u < r.length - 1)
          continue;
        i += u - i + 1;
        break;
      }
    a = s;
  }
  return a;
}, Pt = (t) => t == null ? void 0 : t.replace("_", "-"), qo = {
  type: "logger",
  log(t) {
    this.output("log", t);
  },
  warn(t) {
    this.output("warn", t);
  },
  error(t) {
    this.output("error", t);
  },
  output(t, e) {
    var n, r;
    (r = (n = console == null ? void 0 : console[t]) == null ? void 0 : n.apply) == null || r.call(n, console, e);
  }
};
class kt {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, n);
  }
  init(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = n.prefix || "i18next:", this.logger = e || qo, this.options = n, this.debug = n.debug;
  }
  log() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return this.forward(n, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return this.forward(n, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, n, r, a) {
    return a && !this.debug ? null : (I(e[0]) && (e[0] = `${r}${this.prefix} ${e[0]}`), this.logger[n](e));
  }
  create(e) {
    return new kt(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new kt(this.logger, e);
  }
}
var Pe = new kt();
class At {
  constructor() {
    this.observers = {};
  }
  on(e, n) {
    return e.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const a = this.observers[r].get(n) || 0;
      this.observers[r].set(n, a + 1);
    }), this;
  }
  off(e, n) {
    if (this.observers[e]) {
      if (!n) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(n);
    }
  }
  emit(e) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
      r[a - 1] = arguments[a];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((s) => {
      let [o, u] = s;
      for (let c = 0; c < u; c++)
        o(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((s) => {
      let [o, u] = s;
      for (let c = 0; c < u; c++)
        o.apply(o, [e, ...r]);
    });
  }
}
class ur extends At {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const n = this.options.ns.indexOf(e);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(e, n, r) {
    var c, l;
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, s = a.ignoreJSONStructure !== void 0 ? a.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let o;
    e.indexOf(".") > -1 ? o = e.split(".") : (o = [e, n], r && (Array.isArray(r) ? o.push(...r) : I(r) && i ? o.push(...r.split(i)) : o.push(r)));
    const u = Ct(this.data, o);
    return !u && !n && !r && e.indexOf(".") > -1 && (e = o[0], n = o[1], r = o.slice(2).join(".")), u || !s || !I(r) ? u : on((l = (c = this.data) == null ? void 0 : c[e]) == null ? void 0 : l[n], r, i);
  }
  addResource(e, n, r, a) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const s = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let o = [e, n];
    r && (o = o.concat(s ? r.split(s) : r)), e.indexOf(".") > -1 && (o = e.split("."), a = n, n = o[1]), this.addNamespaces(n), or(this.data, o, a), i.silent || this.emit("added", e, n, r, a);
  }
  addResources(e, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in r)
      (I(r[i]) || Array.isArray(r[i])) && this.addResource(e, n, i, r[i], {
        silent: !0
      });
    a.silent || this.emit("added", e, n, r);
  }
  addResourceBundle(e, n, r, a, i) {
    let s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, o = [e, n];
    e.indexOf(".") > -1 && (o = e.split("."), a = r, r = n, n = o[1]), this.addNamespaces(n);
    let u = Ct(this.data, o) || {};
    s.skipCopy || (r = JSON.parse(JSON.stringify(r))), a ? ca(u, r, i) : u = {
      ...u,
      ...r
    }, or(this.data, o, u), s.silent || this.emit("added", e, n, r);
  }
  removeResourceBundle(e, n) {
    this.hasResourceBundle(e, n) && delete this.data[e][n], this.removeNamespaces(n), this.emit("removed", e, n);
  }
  hasResourceBundle(e, n) {
    return this.getResource(e, n) !== void 0;
  }
  getResourceBundle(e, n) {
    return n || (n = this.options.defaultNS), this.getResource(e, n);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const n = this.getDataByLanguage(e);
    return !!(n && Object.keys(n) || []).find((a) => n[a] && Object.keys(n[a]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var la = {
  processors: {},
  addPostProcessor(t) {
    this.processors[t.name] = t;
  },
  handle(t, e, n, r, a) {
    return t.forEach((i) => {
      var s;
      e = ((s = this.processors[i]) == null ? void 0 : s.process(e, n, r, a)) ?? e;
    }), e;
  }
};
const cr = {};
class Rt extends At {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), _o(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Pe.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const r = this.resolve(e, n);
    return (r == null ? void 0 : r.res) !== void 0;
  }
  extractFromKey(e, n) {
    let r = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const a = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let i = n.ns || this.options.defaultNS || [];
    const s = r && e.indexOf(r) > -1, o = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !zo(e, r, a);
    if (s && !o) {
      const u = e.match(this.interpolator.nestingRegexp);
      if (u && u.length > 0)
        return {
          key: e,
          namespaces: I(i) ? [i] : i
        };
      const c = e.split(r);
      (r !== a || r === a && this.options.ns.indexOf(c[0]) > -1) && (i = c.shift()), e = c.join(a);
    }
    return {
      key: e,
      namespaces: I(i) ? [i] : i
    };
  }
  translate(e, n, r) {
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), e == null) return "";
    Array.isArray(e) || (e = [String(e)]);
    const a = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: s,
      namespaces: o
    } = this.extractFromKey(e[e.length - 1], n), u = o[o.length - 1], c = n.lng || this.language, l = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if ((c == null ? void 0 : c.toLowerCase()) === "cimode") {
      if (l) {
        const T = n.nsSeparator || this.options.nsSeparator;
        return a ? {
          res: `${u}${T}${s}`,
          usedKey: s,
          exactUsedKey: s,
          usedLng: c,
          usedNS: u,
          usedParams: this.getUsedParamsDetails(n)
        } : `${u}${T}${s}`;
      }
      return a ? {
        res: s,
        usedKey: s,
        exactUsedKey: s,
        usedLng: c,
        usedNS: u,
        usedParams: this.getUsedParamsDetails(n)
      } : s;
    }
    const h = this.resolve(e, n);
    let d = h == null ? void 0 : h.res;
    const m = (h == null ? void 0 : h.usedKey) || s, g = (h == null ? void 0 : h.exactUsedKey) || s, w = Object.prototype.toString.apply(d), y = ["[object Number]", "[object Function]", "[object RegExp]"], P = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, E = !this.i18nFormat || this.i18nFormat.handleAsObject, x = !I(d) && typeof d != "boolean" && typeof d != "number";
    if (E && d && x && y.indexOf(w) < 0 && !(I(P) && Array.isArray(d))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const T = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(m, d, {
          ...n,
          ns: o
        }) : `key '${s} (${this.language})' returned an object instead of string.`;
        return a ? (h.res = T, h.usedParams = this.getUsedParamsDetails(n), h) : T;
      }
      if (i) {
        const T = Array.isArray(d), p = T ? [] : {}, S = T ? g : m;
        for (const A in d)
          if (Object.prototype.hasOwnProperty.call(d, A)) {
            const R = `${S}${i}${A}`;
            p[A] = this.translate(R, {
              ...n,
              joinArrays: !1,
              ns: o
            }), p[A] === R && (p[A] = d[A]);
          }
        d = p;
      }
    } else if (E && I(P) && Array.isArray(d))
      d = d.join(P), d && (d = this.extendTranslation(d, e, n, r));
    else {
      let T = !1, p = !1;
      const S = n.count !== void 0 && !I(n.count), A = Rt.hasDefaultValue(n), R = S ? this.pluralResolver.getSuffix(c, n.count, n) : "", V = n.ordinal && S ? this.pluralResolver.getSuffix(c, n.count, {
        ordinal: !1
      }) : "", J = S && !n.ordinal && n.count === 0, q = J && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${R}`] || n[`defaultValue${V}`] || n.defaultValue;
      !this.isValidLookup(d) && A && (T = !0, d = q), this.isValidLookup(d) || (p = !0, d = s);
      const pe = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && p ? void 0 : d, te = A && q !== d && this.options.updateMissing;
      if (p || T || te) {
        if (this.logger.log(te ? "updateKey" : "missingKey", c, u, s, te ? q : d), i) {
          const re = this.resolve(s, {
            ...n,
            keySeparator: !1
          });
          re && re.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let oe = [];
        const ie = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && ie && ie[0])
          for (let re = 0; re < ie.length; re++)
            oe.push(ie[re]);
        else this.options.saveMissingTo === "all" ? oe = this.languageUtils.toResolveHierarchy(n.lng || this.language) : oe.push(n.lng || this.language);
        const K = (re, de, v) => {
          var D;
          const O = A && v !== d ? v : pe;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(re, u, de, O, te, n) : (D = this.backendConnector) != null && D.saveMissing && this.backendConnector.saveMissing(re, u, de, O, te, n), this.emit("missingKey", re, u, de, d);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && S ? oe.forEach((re) => {
          const de = this.pluralResolver.getSuffixes(re, n);
          J && n[`defaultValue${this.options.pluralSeparator}zero`] && de.indexOf(`${this.options.pluralSeparator}zero`) < 0 && de.push(`${this.options.pluralSeparator}zero`), de.forEach((v) => {
            K([re], s + v, n[`defaultValue${v}`] || q);
          });
        }) : K(oe, s, q));
      }
      d = this.extendTranslation(d, e, n, h, r), p && d === s && this.options.appendNamespaceToMissingKey && (d = `${u}:${s}`), (p || T) && this.options.parseMissingKeyHandler && (d = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${u}:${s}` : s, T ? d : void 0));
    }
    return a ? (h.res = d, h.usedParams = this.getUsedParamsDetails(n), h) : d;
  }
  extendTranslation(e, n, r, a, i) {
    var c, l;
    var s = this;
    if ((c = this.i18nFormat) != null && c.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || a.usedLng, a.usedNS, a.usedKey, {
        resolved: a
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const h = I(e) && (((l = r == null ? void 0 : r.interpolation) == null ? void 0 : l.skipOnVariables) !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let d;
      if (h) {
        const g = e.match(this.interpolator.nestingRegexp);
        d = g && g.length;
      }
      let m = r.replace && !I(r.replace) ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (m = {
        ...this.options.interpolation.defaultVariables,
        ...m
      }), e = this.interpolator.interpolate(e, m, r.lng || this.language || a.usedLng, r), h) {
        const g = e.match(this.interpolator.nestingRegexp), w = g && g.length;
        d < w && (r.nest = !1);
      }
      !r.lng && a && a.res && (r.lng = this.language || a.usedLng), r.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var g = arguments.length, w = new Array(g), y = 0; y < g; y++)
          w[y] = arguments[y];
        return (i == null ? void 0 : i[0]) === w[0] && !r.context ? (s.logger.warn(`It seems you are nesting recursively key: ${w[0]} in key: ${n[0]}`), null) : s.translate(...w, n);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const o = r.postProcess || this.options.postProcess, u = I(o) ? [o] : o;
    return e != null && (u != null && u.length) && r.applyPostProcessor !== !1 && (e = la.handle(u, e, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...a,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), e;
  }
  resolve(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, a, i, s, o;
    return I(e) && (e = [e]), e.forEach((u) => {
      if (this.isValidLookup(r)) return;
      const c = this.extractFromKey(u, n), l = c.key;
      a = l;
      let h = c.namespaces;
      this.options.fallbackNS && (h = h.concat(this.options.fallbackNS));
      const d = n.count !== void 0 && !I(n.count), m = d && !n.ordinal && n.count === 0, g = n.context !== void 0 && (I(n.context) || typeof n.context == "number") && n.context !== "", w = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      h.forEach((y) => {
        var P, E;
        this.isValidLookup(r) || (o = y, !cr[`${w[0]}-${y}`] && ((P = this.utils) != null && P.hasLoadedNamespace) && !((E = this.utils) != null && E.hasLoadedNamespace(o)) && (cr[`${w[0]}-${y}`] = !0, this.logger.warn(`key "${a}" for languages "${w.join(", ")}" won't get resolved as namespace "${o}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), w.forEach((x) => {
          var S;
          if (this.isValidLookup(r)) return;
          s = x;
          const T = [l];
          if ((S = this.i18nFormat) != null && S.addLookupKeys)
            this.i18nFormat.addLookupKeys(T, l, x, y, n);
          else {
            let A;
            d && (A = this.pluralResolver.getSuffix(x, n.count, n));
            const R = `${this.options.pluralSeparator}zero`, V = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (d && (T.push(l + A), n.ordinal && A.indexOf(V) === 0 && T.push(l + A.replace(V, this.options.pluralSeparator)), m && T.push(l + R)), g) {
              const J = `${l}${this.options.contextSeparator}${n.context}`;
              T.push(J), d && (T.push(J + A), n.ordinal && A.indexOf(V) === 0 && T.push(J + A.replace(V, this.options.pluralSeparator)), m && T.push(J + R));
            }
          }
          let p;
          for (; p = T.pop(); )
            this.isValidLookup(r) || (i = p, r = this.getResource(x, y, p, n));
        }));
      });
    }), {
      res: r,
      usedKey: a,
      exactUsedKey: i,
      usedLng: s,
      usedNS: o
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, n, r) {
    var i;
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return (i = this.i18nFormat) != null && i.getResource ? this.i18nFormat.getResource(e, n, r, a) : this.resourceStore.getResource(e, n, r, a);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = e.replace && !I(e.replace);
    let a = r ? e.replace : e;
    if (r && typeof e.count < "u" && (a.count = e.count), this.options.interpolation.defaultVariables && (a = {
      ...this.options.interpolation.defaultVariables,
      ...a
    }), !r) {
      a = {
        ...a
      };
      for (const i of n)
        delete a[i];
    }
    return a;
  }
  static hasDefaultValue(e) {
    const n = "defaultValue";
    for (const r in e)
      if (Object.prototype.hasOwnProperty.call(e, r) && n === r.substring(0, n.length) && e[r] !== void 0)
        return !0;
    return !1;
  }
}
class lr {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Pe.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = Pt(e), !e || e.indexOf("-") < 0) return null;
    const n = e.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = Pt(e), !e || e.indexOf("-") < 0) return e;
    const n = e.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(e) {
    if (I(e) && e.indexOf("-") > -1) {
      let n;
      try {
        n = Intl.getCanonicalLocales(e)[0];
      } catch {
      }
      return n && this.options.lowerCaseLng && (n = n.toLowerCase()), n || (this.options.lowerCaseLng ? e.toLowerCase() : e);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e) return null;
    let n;
    return e.forEach((r) => {
      if (n) return;
      const a = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(a)) && (n = a);
    }), !n && this.options.supportedLngs && e.forEach((r) => {
      if (n) return;
      const a = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(a)) return n = a;
      n = this.options.supportedLngs.find((i) => {
        if (i === a) return i;
        if (!(i.indexOf("-") < 0 && a.indexOf("-") < 0) && (i.indexOf("-") > 0 && a.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === a || i.indexOf(a) === 0 && a.length > 1))
          return i;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(e, n) {
    if (!e) return [];
    if (typeof e == "function" && (e = e(n)), I(e) && (e = [e]), Array.isArray(e)) return e;
    if (!n) return e.default || [];
    let r = e[n];
    return r || (r = e[this.getScriptPartFromCode(n)]), r || (r = e[this.formatLanguageCode(n)]), r || (r = e[this.getLanguagePartFromCode(n)]), r || (r = e.default), r || [];
  }
  toResolveHierarchy(e, n) {
    const r = this.getFallbackCodes(n || this.options.fallbackLng || [], e), a = [], i = (s) => {
      s && (this.isSupportedCode(s) ? a.push(s) : this.logger.warn(`rejecting language code not found in supportedLngs: ${s}`));
    };
    return I(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(e))) : I(e) && i(this.formatLanguageCode(e)), r.forEach((s) => {
      a.indexOf(s) < 0 && i(this.formatLanguageCode(s));
    }), a;
  }
}
const fr = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, dr = {
  select: (t) => t === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class Bo {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = n, this.logger = Pe.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(e, n) {
    this.rules[e] = n;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = Pt(e === "dev" ? "en" : e), a = n.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
      cleanedCode: r,
      type: a
    });
    if (i in this.pluralRulesCache)
      return this.pluralRulesCache[i];
    let s;
    try {
      s = new Intl.PluralRules(r, {
        type: a
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), dr;
      if (!e.match(/-|_/)) return dr;
      const u = this.languageUtils.getLanguagePartFromCode(e);
      s = this.getRule(u, n);
    }
    return this.pluralRulesCache[i] = s, s;
  }
  needsPlural(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = this.getRule(e, n);
    return r || (r = this.getRule("dev", n)), (r == null ? void 0 : r.resolvedOptions().pluralCategories.length) > 1;
  }
  getPluralFormsOfKey(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, r).map((a) => `${n}${a}`);
  }
  getSuffixes(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = this.getRule(e, n);
    return r || (r = this.getRule("dev", n)), r ? r.resolvedOptions().pluralCategories.sort((a, i) => fr[a] - fr[i]).map((a) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${a}`) : [];
  }
  getSuffix(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const a = this.getRule(e, r);
    return a ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${a.select(n)}` : (this.logger.warn(`no plural rule found for: ${e}`), this.getSuffix("dev", n, r));
  }
}
const hr = function(t, e, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = Mo(t, e, n);
  return !i && a && I(n) && (i = on(t, n, r), i === void 0 && (i = on(e, n, r))), i;
}, Qt = (t) => t.replace(/\$/g, "$$$$");
class Ho {
  constructor() {
    var n;
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Pe.create("interpolator"), this.options = e, this.format = ((n = e == null ? void 0 : e.interpolation) == null ? void 0 : n.format) || ((r) => r), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: n,
      escapeValue: r,
      useRawValueToEscape: a,
      prefix: i,
      prefixEscaped: s,
      suffix: o,
      suffixEscaped: u,
      formatSeparator: c,
      unescapeSuffix: l,
      unescapePrefix: h,
      nestingPrefix: d,
      nestingPrefixEscaped: m,
      nestingSuffix: g,
      nestingSuffixEscaped: w,
      nestingOptionsSeparator: y,
      maxReplaces: P,
      alwaysFormat: E
    } = e.interpolation;
    this.escape = n !== void 0 ? n : Uo, this.escapeValue = r !== void 0 ? r : !0, this.useRawValueToEscape = a !== void 0 ? a : !1, this.prefix = i ? He(i) : s || "{{", this.suffix = o ? He(o) : u || "}}", this.formatSeparator = c || ",", this.unescapePrefix = l ? "" : h || "-", this.unescapeSuffix = this.unescapePrefix ? "" : l || "", this.nestingPrefix = d ? He(d) : m || He("$t("), this.nestingSuffix = g ? He(g) : w || He(")"), this.nestingOptionsSeparator = y || ",", this.maxReplaces = P || 1e3, this.alwaysFormat = E !== void 0 ? E : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (n, r) => (n == null ? void 0 : n.source) === r ? (n.lastIndex = 0, n) : new RegExp(r, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, n, r, a) {
    var m;
    let i, s, o;
    const u = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (g) => {
      if (g.indexOf(this.formatSeparator) < 0) {
        const E = hr(n, u, g, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(E, void 0, r, {
          ...a,
          ...n,
          interpolationkey: g
        }) : E;
      }
      const w = g.split(this.formatSeparator), y = w.shift().trim(), P = w.join(this.formatSeparator).trim();
      return this.format(hr(n, u, y, this.options.keySeparator, this.options.ignoreJSONStructure), P, r, {
        ...a,
        ...n,
        interpolationkey: y
      });
    };
    this.resetRegExp();
    const l = (a == null ? void 0 : a.missingInterpolationHandler) || this.options.missingInterpolationHandler, h = ((m = a == null ? void 0 : a.interpolation) == null ? void 0 : m.skipOnVariables) !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (g) => Qt(g)
    }, {
      regex: this.regexp,
      safeValue: (g) => this.escapeValue ? Qt(this.escape(g)) : Qt(g)
    }].forEach((g) => {
      for (o = 0; i = g.regex.exec(e); ) {
        const w = i[1].trim();
        if (s = c(w), s === void 0)
          if (typeof l == "function") {
            const P = l(e, i, a);
            s = I(P) ? P : "";
          } else if (a && Object.prototype.hasOwnProperty.call(a, w))
            s = "";
          else if (h) {
            s = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${w} for interpolating ${e}`), s = "";
        else !I(s) && !this.useRawValueToEscape && (s = ar(s));
        const y = g.safeValue(s);
        if (e = e.replace(i[0], y), h ? (g.regex.lastIndex += s.length, g.regex.lastIndex -= i[0].length) : g.regex.lastIndex = 0, o++, o >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a, i, s;
    const o = (u, c) => {
      const l = this.nestingOptionsSeparator;
      if (u.indexOf(l) < 0) return u;
      const h = u.split(new RegExp(`${l}[ ]*{`));
      let d = `{${h[1]}`;
      u = h[0], d = this.interpolate(d, s);
      const m = d.match(/'/g), g = d.match(/"/g);
      (((m == null ? void 0 : m.length) ?? 0) % 2 === 0 && !g || g.length % 2 !== 0) && (d = d.replace(/'/g, '"'));
      try {
        s = JSON.parse(d), c && (s = {
          ...c,
          ...s
        });
      } catch (w) {
        return this.logger.warn(`failed parsing options string in nesting for key ${u}`, w), `${u}${l}${d}`;
      }
      return s.defaultValue && s.defaultValue.indexOf(this.prefix) > -1 && delete s.defaultValue, u;
    };
    for (; a = this.nestingRegexp.exec(e); ) {
      let u = [];
      s = {
        ...r
      }, s = s.replace && !I(s.replace) ? s.replace : s, s.applyPostProcessor = !1, delete s.defaultValue;
      let c = !1;
      if (a[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(a[1])) {
        const l = a[1].split(this.formatSeparator).map((h) => h.trim());
        a[1] = l.shift(), u = l, c = !0;
      }
      if (i = n(o.call(this, a[1].trim(), s), s), i && a[0] === e && !I(i)) return i;
      I(i) || (i = ar(i)), i || (this.logger.warn(`missed to resolve ${a[1]} for nesting ${e}`), i = ""), c && (i = u.reduce((l, h) => this.format(l, h, r.lng, {
        ...r,
        interpolationkey: a[1].trim()
      }), i.trim())), e = e.replace(a[0], i), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const Ko = (t) => {
  let e = t.toLowerCase().trim();
  const n = {};
  if (t.indexOf("(") > -1) {
    const r = t.split("(");
    e = r[0].toLowerCase().trim();
    const a = r[1].substring(0, r[1].length - 1);
    e === "currency" && a.indexOf(":") < 0 ? n.currency || (n.currency = a.trim()) : e === "relativetime" && a.indexOf(":") < 0 ? n.range || (n.range = a.trim()) : a.split(";").forEach((s) => {
      if (s) {
        const [o, ...u] = s.split(":"), c = u.join(":").trim().replace(/^'+|'+$/g, ""), l = o.trim();
        n[l] || (n[l] = c), c === "false" && (n[l] = !1), c === "true" && (n[l] = !0), isNaN(c) || (n[l] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: n
  };
}, Ke = (t) => {
  const e = {};
  return (n, r, a) => {
    let i = a;
    a && a.interpolationkey && a.formatParams && a.formatParams[a.interpolationkey] && a[a.interpolationkey] && (i = {
      ...i,
      [a.interpolationkey]: void 0
    });
    const s = r + JSON.stringify(i);
    let o = e[s];
    return o || (o = t(Pt(r), a), e[s] = o), o(n);
  };
};
class Go {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Pe.create("formatter"), this.options = e, this.formats = {
      number: Ke((n, r) => {
        const a = new Intl.NumberFormat(n, {
          ...r
        });
        return (i) => a.format(i);
      }),
      currency: Ke((n, r) => {
        const a = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (i) => a.format(i);
      }),
      datetime: Ke((n, r) => {
        const a = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (i) => a.format(i);
      }),
      relativetime: Ke((n, r) => {
        const a = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (i) => a.format(i, r.range || "day");
      }),
      list: Ke((n, r) => {
        const a = new Intl.ListFormat(n, {
          ...r
        });
        return (i) => a.format(i);
      })
    }, this.init(e);
  }
  init(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = n.interpolation.formatSeparator || ",";
  }
  add(e, n) {
    this.formats[e.toLowerCase().trim()] = n;
  }
  addCached(e, n) {
    this.formats[e.toLowerCase().trim()] = Ke(n);
  }
  format(e, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = n.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((o) => o.indexOf(")") > -1)) {
      const o = i.findIndex((u) => u.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, o)].join(this.formatSeparator);
    }
    return i.reduce((o, u) => {
      var h;
      const {
        formatName: c,
        formatOptions: l
      } = Ko(u);
      if (this.formats[c]) {
        let d = o;
        try {
          const m = ((h = a == null ? void 0 : a.formatParams) == null ? void 0 : h[a.interpolationkey]) || {}, g = m.locale || m.lng || a.locale || a.lng || r;
          d = this.formats[c](o, g, {
            ...l,
            ...a,
            ...m
          });
        } catch (m) {
          this.logger.warn(m);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return o;
    }, e);
  }
}
const Jo = (t, e) => {
  t.pending[e] !== void 0 && (delete t.pending[e], t.pendingCount--);
};
class Qo extends At {
  constructor(e, n, r) {
    var i, s;
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = n, this.services = r, this.languageUtils = r.languageUtils, this.options = a, this.logger = Pe.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = a.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = a.maxRetries >= 0 ? a.maxRetries : 5, this.retryTimeout = a.retryTimeout >= 1 ? a.retryTimeout : 350, this.state = {}, this.queue = [], (s = (i = this.backend) == null ? void 0 : i.init) == null || s.call(i, r, a.backend, a);
  }
  queueLoad(e, n, r, a) {
    const i = {}, s = {}, o = {}, u = {};
    return e.forEach((c) => {
      let l = !0;
      n.forEach((h) => {
        const d = `${c}|${h}`;
        !r.reload && this.store.hasResourceBundle(c, h) ? this.state[d] = 2 : this.state[d] < 0 || (this.state[d] === 1 ? s[d] === void 0 && (s[d] = !0) : (this.state[d] = 1, l = !1, s[d] === void 0 && (s[d] = !0), i[d] === void 0 && (i[d] = !0), u[h] === void 0 && (u[h] = !0)));
      }), l || (o[c] = !0);
    }), (Object.keys(i).length || Object.keys(s).length) && this.queue.push({
      pending: s,
      pendingCount: Object.keys(s).length,
      loaded: {},
      errors: [],
      callback: a
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(s),
      toLoadLanguages: Object.keys(o),
      toLoadNamespaces: Object.keys(u)
    };
  }
  loaded(e, n, r) {
    const a = e.split("|"), i = a[0], s = a[1];
    n && this.emit("failedLoading", i, s, n), !n && r && this.store.addResourceBundle(i, s, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = n ? -1 : 2, n && r && (this.state[e] = 0);
    const o = {};
    this.queue.forEach((u) => {
      jo(u.loaded, [i], s), Jo(u, e), n && u.errors.push(n), u.pendingCount === 0 && !u.done && (Object.keys(u.loaded).forEach((c) => {
        o[c] || (o[c] = {});
        const l = u.loaded[c];
        l.length && l.forEach((h) => {
          o[c][h] === void 0 && (o[c][h] = !0);
        });
      }), u.done = !0, u.errors.length ? u.callback(u.errors) : u.callback());
    }), this.emit("loaded", o), this.queue = this.queue.filter((u) => !u.done);
  }
  read(e, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, s = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length) return s(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: n,
        fcName: r,
        tried: a,
        wait: i,
        callback: s
      });
      return;
    }
    this.readingCalls++;
    const o = (c, l) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const h = this.waitingReads.shift();
        this.read(h.lng, h.ns, h.fcName, h.tried, h.wait, h.callback);
      }
      if (c && l && a < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, n, r, a + 1, i * 2, s);
        }, i);
        return;
      }
      s(c, l);
    }, u = this.backend[r].bind(this.backend);
    if (u.length === 2) {
      try {
        const c = u(e, n);
        c && typeof c.then == "function" ? c.then((l) => o(null, l)).catch(o) : o(null, c);
      } catch (c) {
        o(c);
      }
      return;
    }
    return u(e, n, o);
  }
  prepareLoading(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), a && a();
    I(e) && (e = this.languageUtils.toResolveHierarchy(e)), I(n) && (n = [n]);
    const i = this.queueLoad(e, n, r, a);
    if (!i.toLoad.length)
      return i.pending.length || a(), null;
    i.toLoad.forEach((s) => {
      this.loadOne(s);
    });
  }
  load(e, n, r) {
    this.prepareLoading(e, n, {}, r);
  }
  reload(e, n, r) {
    this.prepareLoading(e, n, {
      reload: !0
    }, r);
  }
  loadOne(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = e.split("|"), a = r[0], i = r[1];
    this.read(a, i, "read", void 0, void 0, (s, o) => {
      s && this.logger.warn(`${n}loading namespace ${i} for language ${a} failed`, s), !s && o && this.logger.log(`${n}loaded namespace ${i} for language ${a}`, o), this.loaded(e, s, o);
    });
  }
  saveMissing(e, n, r, a, i) {
    var u, c, l, h, d;
    let s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if ((c = (u = this.services) == null ? void 0 : u.utils) != null && c.hasLoadedNamespace && !((h = (l = this.services) == null ? void 0 : l.utils) != null && h.hasLoadedNamespace(n))) {
      this.logger.warn(`did not save key "${r}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if ((d = this.backend) != null && d.create) {
        const m = {
          ...s,
          isUpdate: i
        }, g = this.backend.create.bind(this.backend);
        if (g.length < 6)
          try {
            let w;
            g.length === 5 ? w = g(e, n, r, a, m) : w = g(e, n, r, a), w && typeof w.then == "function" ? w.then((y) => o(null, y)).catch(o) : o(null, w);
          } catch (w) {
            o(w);
          }
        else
          g(e, n, r, a, o, m);
      }
      !e || !e[0] || this.store.addResource(e[0], n, r, a);
    }
  }
}
const pr = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (t) => {
    let e = {};
    if (typeof t[1] == "object" && (e = t[1]), I(t[1]) && (e.defaultValue = t[1]), I(t[2]) && (e.tDescription = t[2]), typeof t[2] == "object" || typeof t[3] == "object") {
      const n = t[3] || t[2];
      Object.keys(n).forEach((r) => {
        e[r] = n[r];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (t) => t,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), gr = (t) => {
  var e, n;
  return I(t.ns) && (t.ns = [t.ns]), I(t.fallbackLng) && (t.fallbackLng = [t.fallbackLng]), I(t.fallbackNS) && (t.fallbackNS = [t.fallbackNS]), ((n = (e = t.supportedLngs) == null ? void 0 : e.indexOf) == null ? void 0 : n.call(e, "cimode")) < 0 && (t.supportedLngs = t.supportedLngs.concat(["cimode"])), typeof t.initImmediate == "boolean" && (t.initAsync = t.initImmediate), t;
}, vt = () => {
}, Xo = (t) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(t)).forEach((n) => {
    typeof t[n] == "function" && (t[n] = t[n].bind(t));
  });
};
class lt extends At {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = gr(e), this.services = {}, this.logger = Pe, this.modules = {
      external: []
    }, Xo(this), n && !this.isInitialized && !e.isClone) {
      if (!this.options.initAsync)
        return this.init(e, n), this;
      setTimeout(() => {
        this.init(e, n);
      }, 0);
    }
  }
  init() {
    var e = this;
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof n == "function" && (r = n, n = {}), !n.defaultNS && n.defaultNS !== !1 && n.ns && (I(n.ns) ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
    const a = pr();
    this.options = {
      ...a,
      ...this.options,
      ...gr(n)
    }, this.options.interpolation = {
      ...a.interpolation,
      ...this.options.interpolation
    }, n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator);
    const i = (l) => l ? typeof l == "function" ? new l() : l : null;
    if (!this.options.isClone) {
      this.modules.logger ? Pe.init(i(this.modules.logger), this.options) : Pe.init(null, this.options);
      let l;
      this.modules.formatter ? l = this.modules.formatter : l = Go;
      const h = new lr(this.options);
      this.store = new ur(this.options.resources, this.options);
      const d = this.services;
      d.logger = Pe, d.resourceStore = this.store, d.languageUtils = h, d.pluralResolver = new Bo(h, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), l && (!this.options.interpolation.format || this.options.interpolation.format === a.interpolation.format) && (d.formatter = i(l), d.formatter.init(d, this.options), this.options.interpolation.format = d.formatter.format.bind(d.formatter)), d.interpolator = new Ho(this.options), d.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, d.backendConnector = new Qo(i(this.modules.backend), d.resourceStore, d, this.options), d.backendConnector.on("*", function(m) {
        for (var g = arguments.length, w = new Array(g > 1 ? g - 1 : 0), y = 1; y < g; y++)
          w[y - 1] = arguments[y];
        e.emit(m, ...w);
      }), this.modules.languageDetector && (d.languageDetector = i(this.modules.languageDetector), d.languageDetector.init && d.languageDetector.init(d, this.options.detection, this.options)), this.modules.i18nFormat && (d.i18nFormat = i(this.modules.i18nFormat), d.i18nFormat.init && d.i18nFormat.init(this)), this.translator = new Rt(this.services, this.options), this.translator.on("*", function(m) {
        for (var g = arguments.length, w = new Array(g > 1 ? g - 1 : 0), y = 1; y < g; y++)
          w[y - 1] = arguments[y];
        e.emit(m, ...w);
      }), this.modules.external.forEach((m) => {
        m.init && m.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = vt), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const l = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      l.length > 0 && l[0] !== "dev" && (this.options.lng = l[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((l) => {
      this[l] = function() {
        return e.store[l](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((l) => {
      this[l] = function() {
        return e.store[l](...arguments), e;
      };
    });
    const u = tt(), c = () => {
      const l = (h, d) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), u.resolve(d), r(h, d);
      };
      if (this.languages && !this.isInitialized) return l(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, l);
    };
    return this.options.resources || !this.options.initAsync ? c() : setTimeout(c, 0), u;
  }
  loadResources(e) {
    var i, s;
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : vt;
    const a = I(e) ? e : this.language;
    if (typeof e == "function" && (r = e), !this.options.resources || this.options.partialBundledLanguages) {
      if ((a == null ? void 0 : a.toLowerCase()) === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return r();
      const o = [], u = (c) => {
        if (!c || c === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(c).forEach((h) => {
          h !== "cimode" && o.indexOf(h) < 0 && o.push(h);
        });
      };
      a ? u(a) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => u(l)), (s = (i = this.options.preload) == null ? void 0 : i.forEach) == null || s.call(i, (c) => u(c)), this.services.backendConnector.load(o, this.options.ns, (c) => {
        !c && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(c);
      });
    } else
      r(null);
  }
  reloadResources(e, n, r) {
    const a = tt();
    return typeof e == "function" && (r = e, e = void 0), typeof n == "function" && (r = n, n = void 0), e || (e = this.languages), n || (n = this.options.ns), r || (r = vt), this.services.backendConnector.reload(e, n, (i) => {
      a.resolve(), r(i);
    }), a;
  }
  use(e) {
    if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && la.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let n = 0; n < this.languages.length; n++) {
        const r = this.languages[n];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(e, n) {
    var r = this;
    this.isLanguageChangingTo = e;
    const a = tt();
    this.emit("languageChanging", e);
    const i = (u) => {
      this.language = u, this.languages = this.services.languageUtils.toResolveHierarchy(u), this.resolvedLanguage = void 0, this.setResolvedLanguage(u);
    }, s = (u, c) => {
      c ? (i(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, a.resolve(function() {
        return r.t(...arguments);
      }), n && n(u, function() {
        return r.t(...arguments);
      });
    }, o = (u) => {
      var l, h;
      !e && !u && this.services.languageDetector && (u = []);
      const c = I(u) ? u : this.services.languageUtils.getBestMatchFromCodes(u);
      c && (this.language || i(c), this.translator.language || this.translator.changeLanguage(c), (h = (l = this.services.languageDetector) == null ? void 0 : l.cacheUserLanguage) == null || h.call(l, c)), this.loadResources(c, (d) => {
        s(d, c);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? o(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(o) : this.services.languageDetector.detect(o) : o(e), a;
  }
  getFixedT(e, n, r) {
    var a = this;
    const i = function(s, o) {
      let u;
      if (typeof o != "object") {
        for (var c = arguments.length, l = new Array(c > 2 ? c - 2 : 0), h = 2; h < c; h++)
          l[h - 2] = arguments[h];
        u = a.options.overloadTranslationOptionHandler([s, o].concat(l));
      } else
        u = {
          ...o
        };
      u.lng = u.lng || i.lng, u.lngs = u.lngs || i.lngs, u.ns = u.ns || i.ns, u.keyPrefix !== "" && (u.keyPrefix = u.keyPrefix || r || i.keyPrefix);
      const d = a.options.keySeparator || ".";
      let m;
      return u.keyPrefix && Array.isArray(s) ? m = s.map((g) => `${u.keyPrefix}${d}${g}`) : m = u.keyPrefix ? `${u.keyPrefix}${d}${s}` : s, a.t(m, u);
    };
    return I(e) ? i.lng = e : i.lngs = e, i.ns = n, i.keyPrefix = r, i;
  }
  t() {
    var a;
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return (a = this.translator) == null ? void 0 : a.translate(...n);
  }
  exists() {
    var a;
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return (a = this.translator) == null ? void 0 : a.exists(...n);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = n.lng || this.resolvedLanguage || this.languages[0], a = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode") return !0;
    const s = (o, u) => {
      const c = this.services.backendConnector.state[`${o}|${u}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (n.precheck) {
      const o = n.precheck(this, s);
      if (o !== void 0) return o;
    }
    return !!(this.hasResourceBundle(r, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || s(r, e) && (!a || s(i, e)));
  }
  loadNamespaces(e, n) {
    const r = tt();
    return this.options.ns ? (I(e) && (e = [e]), e.forEach((a) => {
      this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
    }), this.loadResources((a) => {
      r.resolve(), n && n(a);
    }), r) : (n && n(), Promise.resolve());
  }
  loadLanguages(e, n) {
    const r = tt();
    I(e) && (e = [e]);
    const a = this.options.preload || [], i = e.filter((s) => a.indexOf(s) < 0 && this.services.languageUtils.isSupportedCode(s));
    return i.length ? (this.options.preload = a.concat(i), this.loadResources((s) => {
      r.resolve(), n && n(s);
    }), r) : (n && n(), Promise.resolve());
  }
  dir(e) {
    var a, i;
    if (e || (e = this.resolvedLanguage || (((a = this.languages) == null ? void 0 : a.length) > 0 ? this.languages[0] : this.language)), !e) return "rtl";
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = ((i = this.services) == null ? void 0 : i.languageUtils) || new lr(pr());
    return n.indexOf(r.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    return new lt(e, n);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : vt;
    const r = e.forkResourceStore;
    r && delete e.forkResourceStore;
    const a = {
      ...this.options,
      ...e,
      isClone: !0
    }, i = new lt(a);
    if ((e.debug !== void 0 || e.prefix !== void 0) && (i.logger = i.logger.clone(e)), ["store", "services", "language"].forEach((o) => {
      i[o] = this[o];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, r) {
      const o = Object.keys(this.store.data).reduce((u, c) => (u[c] = {
        ...this.store.data[c]
      }, Object.keys(u[c]).reduce((l, h) => (l[h] = {
        ...u[c][h]
      }, l), {})), {});
      i.store = new ur(o, a), i.services.resourceStore = i.store;
    }
    return i.translator = new Rt(i.services, a), i.translator.on("*", function(o) {
      for (var u = arguments.length, c = new Array(u > 1 ? u - 1 : 0), l = 1; l < u; l++)
        c[l - 1] = arguments[l];
      i.emit(o, ...c);
    }), i.init(a, n), i.translator.options = a, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const ge = lt.createInstance();
ge.createInstance = lt.createInstance;
ge.createInstance;
ge.dir;
ge.init;
ge.loadResources;
ge.reloadResources;
ge.use;
ge.changeLanguage;
ge.getFixedT;
ge.t;
ge.exists;
ge.setDefaultNamespace;
ge.hasLoadedNamespace;
ge.loadNamespaces;
ge.loadLanguages;
const {
  slice: Zo,
  forEach: eu
} = [];
function tu(t) {
  return eu.call(Zo.call(arguments, 1), (e) => {
    if (e)
      for (const n in e)
        t[n] === void 0 && (t[n] = e[n]);
  }), t;
}
const mr = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, nu = function(t, e) {
  const r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    path: "/"
  }, a = encodeURIComponent(e);
  let i = `${t}=${a}`;
  if (r.maxAge > 0) {
    const s = r.maxAge - 0;
    if (Number.isNaN(s)) throw new Error("maxAge should be a Number");
    i += `; Max-Age=${Math.floor(s)}`;
  }
  if (r.domain) {
    if (!mr.test(r.domain))
      throw new TypeError("option domain is invalid");
    i += `; Domain=${r.domain}`;
  }
  if (r.path) {
    if (!mr.test(r.path))
      throw new TypeError("option path is invalid");
    i += `; Path=${r.path}`;
  }
  if (r.expires) {
    if (typeof r.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    i += `; Expires=${r.expires.toUTCString()}`;
  }
  if (r.httpOnly && (i += "; HttpOnly"), r.secure && (i += "; Secure"), r.sameSite)
    switch (typeof r.sameSite == "string" ? r.sameSite.toLowerCase() : r.sameSite) {
      case !0:
        i += "; SameSite=Strict";
        break;
      case "lax":
        i += "; SameSite=Lax";
        break;
      case "strict":
        i += "; SameSite=Strict";
        break;
      case "none":
        i += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  return i;
}, yr = {
  create(t, e, n, r) {
    let a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    n && (a.expires = /* @__PURE__ */ new Date(), a.expires.setTime(a.expires.getTime() + n * 60 * 1e3)), r && (a.domain = r), document.cookie = nu(t, encodeURIComponent(e), a);
  },
  read(t) {
    const e = `${t}=`, n = document.cookie.split(";");
    for (let r = 0; r < n.length; r++) {
      let a = n[r];
      for (; a.charAt(0) === " "; ) a = a.substring(1, a.length);
      if (a.indexOf(e) === 0) return a.substring(e.length, a.length);
    }
    return null;
  },
  remove(t) {
    this.create(t, "", -1);
  }
};
var ru = {
  name: "cookie",
  // Deconstruct the options object and extract the lookupCookie property
  lookup(t) {
    let {
      lookupCookie: e
    } = t;
    if (e && typeof document < "u")
      return yr.read(e) || void 0;
  },
  // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
  cacheUserLanguage(t, e) {
    let {
      lookupCookie: n,
      cookieMinutes: r,
      cookieDomain: a,
      cookieOptions: i
    } = e;
    n && typeof document < "u" && yr.create(n, t, r, a, i);
  }
}, au = {
  name: "querystring",
  // Deconstruct the options object and extract the lookupQuerystring property
  lookup(t) {
    var r;
    let {
      lookupQuerystring: e
    } = t, n;
    if (typeof window < "u") {
      let {
        search: a
      } = window.location;
      !window.location.search && ((r = window.location.hash) == null ? void 0 : r.indexOf("?")) > -1 && (a = window.location.hash.substring(window.location.hash.indexOf("?")));
      const s = a.substring(1).split("&");
      for (let o = 0; o < s.length; o++) {
        const u = s[o].indexOf("=");
        u > 0 && s[o].substring(0, u) === e && (n = s[o].substring(u + 1));
      }
    }
    return n;
  }
};
let nt = null;
const vr = () => {
  if (nt !== null) return nt;
  try {
    nt = window !== "undefined" && window.localStorage !== null;
    const t = "i18next.translate.boo";
    window.localStorage.setItem(t, "foo"), window.localStorage.removeItem(t);
  } catch {
    nt = !1;
  }
  return nt;
};
var iu = {
  name: "localStorage",
  // Deconstruct the options object and extract the lookupLocalStorage property
  lookup(t) {
    let {
      lookupLocalStorage: e
    } = t;
    if (e && vr())
      return window.localStorage.getItem(e) || void 0;
  },
  // Deconstruct the options object and extract the lookupLocalStorage property
  cacheUserLanguage(t, e) {
    let {
      lookupLocalStorage: n
    } = e;
    n && vr() && window.localStorage.setItem(n, t);
  }
};
let rt = null;
const br = () => {
  if (rt !== null) return rt;
  try {
    rt = window !== "undefined" && window.sessionStorage !== null;
    const t = "i18next.translate.boo";
    window.sessionStorage.setItem(t, "foo"), window.sessionStorage.removeItem(t);
  } catch {
    rt = !1;
  }
  return rt;
};
var su = {
  name: "sessionStorage",
  lookup(t) {
    let {
      lookupSessionStorage: e
    } = t;
    if (e && br())
      return window.sessionStorage.getItem(e) || void 0;
  },
  cacheUserLanguage(t, e) {
    let {
      lookupSessionStorage: n
    } = e;
    n && br() && window.sessionStorage.setItem(n, t);
  }
}, ou = {
  name: "navigator",
  lookup(t) {
    const e = [];
    if (typeof navigator < "u") {
      const {
        languages: n,
        userLanguage: r,
        language: a
      } = navigator;
      if (n)
        for (let i = 0; i < n.length; i++)
          e.push(n[i]);
      r && e.push(r), a && e.push(a);
    }
    return e.length > 0 ? e : void 0;
  }
}, uu = {
  name: "htmlTag",
  // Deconstruct the options object and extract the htmlTag property
  lookup(t) {
    let {
      htmlTag: e
    } = t, n;
    const r = e || (typeof document < "u" ? document.documentElement : null);
    return r && typeof r.getAttribute == "function" && (n = r.getAttribute("lang")), n;
  }
}, cu = {
  name: "path",
  // Deconstruct the options object and extract the lookupFromPathIndex property
  lookup(t) {
    var a;
    let {
      lookupFromPathIndex: e
    } = t;
    if (typeof window > "u") return;
    const n = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
    return Array.isArray(n) ? (a = n[typeof e == "number" ? e : 0]) == null ? void 0 : a.replace("/", "") : void 0;
  }
}, lu = {
  name: "subdomain",
  lookup(t) {
    var a, i;
    let {
      lookupFromSubdomainIndex: e
    } = t;
    const n = typeof e == "number" ? e + 1 : 1, r = typeof window < "u" && ((i = (a = window.location) == null ? void 0 : a.hostname) == null ? void 0 : i.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i));
    if (r)
      return r[n];
  }
};
let fa = !1;
try {
  document.cookie, fa = !0;
} catch {
}
const da = ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"];
fa || da.splice(1, 1);
const fu = () => ({
  order: da,
  lookupQuerystring: "lng",
  lookupCookie: "i18next",
  lookupLocalStorage: "i18nextLng",
  lookupSessionStorage: "i18nextLng",
  // cache user language
  caches: ["localStorage"],
  excludeCacheFor: ["cimode"],
  // cookieMinutes: 10,
  // cookieDomain: 'myDomain'
  convertDetectedLanguage: (t) => t
});
class ha {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.type = "languageDetector", this.detectors = {}, this.init(e, n);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
      languageUtils: {}
    }, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    this.services = e, this.options = tu(n, this.options || {}, fu()), typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = (a) => a.replace("-", "_")), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = r, this.addDetector(ru), this.addDetector(au), this.addDetector(iu), this.addDetector(su), this.addDetector(ou), this.addDetector(uu), this.addDetector(cu), this.addDetector(lu);
  }
  addDetector(e) {
    return this.detectors[e.name] = e, this;
  }
  detect() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.options.order, n = [];
    return e.forEach((r) => {
      if (this.detectors[r]) {
        let a = this.detectors[r].lookup(this.options);
        a && typeof a == "string" && (a = [a]), a && (n = n.concat(a));
      }
    }), n = n.map((r) => this.options.convertDetectedLanguage(r)), this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes ? n : n.length > 0 ? n[0] : null;
  }
  cacheUserLanguage(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.options.caches;
    n && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(e) > -1 || n.forEach((r) => {
      this.detectors[r] && this.detectors[r].cacheUserLanguage(e, this.options);
    }));
  }
}
ha.type = "languageDetector";
const du = "Close", hu = "Tag", pu = {
  "All the modifications you have made before this time are currently live on your website.": "All the modifications made before this time are currently live on your website.",
  close: du,
  "It looks like your AB Tasty library is empty. This means that your campaigns are temporarily deactivated.\n  To continue running you campaigns, click Recreate library directly from the dashboard or Rebuild framework in the Settings.": "It seems that the AB Tasty script is empty. This means that your campaigns are temporarily deactivated.To continue running your campaigns, click Rebuild script directly from the campaign list or in the Settings.",
  "Last successful update: {{- lastUpdate}}. All the modifications you have made after this time are not live on your website.": "Last successful update: {{- lastUpdate}}. All the modifications made after this time are not live on your website.",
  "Last update : ": "Last update:",
  "Last update has been forced. The identified error(s) are still present on your account. Please <2>check and correct them</2> before updating your tag again.": "We have identified error(s) on your account. Please <2>check and correct them</2> before updating your tag again.",
  "Once you update the tag, all changes made to your active campaigns and/or account settings since the last update will be visible in production.": "Once you update the tag, all changes made to your active campaigns and/or account settings since the last update will be visible in production. ",
  "Oops, you tag has not been updated as we have detected errors on you account. Please <2>check and correct them</2> before updating your tag again.": "Oops, your tag was not updated as we have identified errors on your account. Please <2>check and correct them</2> before updating your tag again.",
  "Oops, your tag has been updated but we have detected errors on your account. Please <2>check and correct them</2> before updating your tag again.": "Oops, we have detected one or several errors on your account. Please <2>check and correct them</2> before updating your tag again.",
  "Option not available": "Option not available",
  "Please update the tag to validate your changes.": "Please update the tag to validate your changes.",
  "Processing compilation": "Compilation",
  "Publishing modifications": "Publishing modifications",
  "Sending request": "Sending request",
  "Sending to server": "Sending to server ",
  "Sorry, your tag has not been updated as we encountered an error on our side... Please try again later.": "Oops, your tag was not updated as an error occurred on our side... Please try again later.",
  Tag: hu,
  "Tag version: ": "Tag version:",
  "You can't update your tag as your account is currently inactive.": "You can’t update your tag as your account is currently inactive.",
  "Your access level does not allow you to perform this action, contact the owner of the account to increase your level of access.": "Oh no, your current user right doesn't allow you to perform this action. Please contact the administrator of the account.",
  "Your tag has been successfully updated": "Your tag has been successfully updated",
  "Your tag has been successfully updated on the {{- lastUpdate}}": "Your tag has been successfully updated on the {{- lastUpdate}}"
}, gu = "Fermer", mu = "Tag", yu = {
  "All the modifications you have made before this time are currently live on your website.": "Les modifications effectuées avant cette date sont actuellement en ligne sur votre site.",
  close: gu,
  "It looks like your AB Tasty library is empty. This means that your campaigns are temporarily deactivated.\n  To continue running you campaigns, click Recreate library directly from the dashboard or Rebuild framework in the Settings.": `Il semblerait que votre script AB Tasty est vide. Cela signifie que vos campagnes sont temporairement désactivées.
Pour continuer à éxécuter vos campagnes, cliquez sur 'Recréer le script' directement depuis la liste de campagnes ou depuis les Paramètres.`,
  "Last successful update: {{- lastUpdate}}. All the modifications you have made after this time are not live on your website.": "Dernière mise à jour réussie {{- lastUpdate}}. Les modifications effectuées après cette date ne sont pas en ligne sur votre site.",
  "Last update : ": "Dernière mise à jour :",
  "Last update has been forced. The identified error(s) are still present on your account. Please <2>check and correct them</2> before updating your tag again.": "Nous avons identifié une ou plusieurs erreurs sur votre compte. Veuillez les <2>vérifier et les corriger</2> avant de recompiler votre tag.",
  "Once you update the tag, all changes made to your active campaigns and/or account settings since the last update will be visible in production.": "En mettant à jour le tag, tous les changements effectués sur l'ensemble de vos campagnes actives et/ou dans les paramètres de votre compte depuis la dernière mise à jour seront visibles en production.",
  "Oops, you tag has not been updated as we have detected errors on you account. Please <2>check and correct them</2> before updating your tag again.": "Oups, votre tag n'a pas pu être mis à jour car nous avons détecté des erreurs sur votre compte. Veuillez <2>les vérifier et les corriger</2> avant d'essayer de remettre votre tag à jour.",
  "Oops, your tag has been updated but we have detected errors on your account. Please <2>check and correct them</2> before updating your tag again.": "Oups, nous avons détecté des erreurs sur votre compte. Veuillez <2>les vérifier et les corriger</2> avant de relancer une compilation.",
  "Option not available": "Option indisponible",
  "Please update the tag to validate your changes.": "Veuillez mettre à jour le tag pour valider les changements effectués.",
  "Processing compilation": "Compilation",
  "Publishing modifications": "Mise en ligne des modifications",
  "Sending request": "Envoi de la demande",
  "Sending to server": "Envoi au serveur",
  "Sorry, your tag has not been updated as we encountered an error on our side... Please try again later.": "Oups, votre tag n'a pas pu être mis à jour car une erreur s'est produite... Veuillez réessayer plus tard.",
  Tag: mu,
  "Tag version: ": "Version du tag :",
  "You can't update your tag as your account is currently inactive.": "Vous ne pouvez pas mettre votre tag à jour car votre compte est actuellement inactif.",
  "Your access level does not allow you to perform this action, contact the owner of the account to increase your level of access.": "Oh non, votre droit utilisateur actuel ne vous permet pas d'effectuer cette action. Veuillez contacter l'administrateur du compte.",
  "Your tag has been successfully updated": "Votre tag a bien été mis à jour.",
  "Your tag has been successfully updated on the {{- lastUpdate}}": "Votre tag a bien été mis à jour le {{- lastUpdate}}"
}, vu = "Cerrar", bu = "Tag", wu = {
  "All the modifications you have made before this time are currently live on your website.": "Todas las modificaciones realizadas antes de esta fecha están actualmente desplegadas en tu web",
  close: vu,
  "It looks like your AB Tasty library is empty. This means that your campaigns are temporarily deactivated.\n  To continue running you campaigns, click Recreate library directly from the dashboard or Rebuild framework in the Settings.": `Parece que el script AB Tasty está vacío. Esto significa que tus campañas están temporalmente desactivadas.
Para seguir ejecutando tus campañas, haz clic en Reconstruir script directamente desde la lista de campañas o en los Ajustes.`,
  "Last successful update: {{- lastUpdate}}. All the modifications you have made after this time are not live on your website.": "Última actualización con éxito: {{- lastUpdate}}. Todas las modificaciones realizadas después de esta fecha no están desplegadas en tu web.",
  "Last update : ": "Última actualización:",
  "Last update has been forced. The identified error(s) are still present on your account. Please <2>check and correct them</2> before updating your tag again.": "Hemos identificado error(es) en su cuenta. Por favor, <2>compruébalos y corrígelos</2> antes de volver a actualizar tu tag.",
  "Once you update the tag, all changes made to your active campaigns and/or account settings since the last update will be visible in production.": "Una vez que actualices el tag, todos los cambios realizados en tus campañas activas y/o cuentas desde la última actualización serán visibles en producción.",
  "Oops, you tag has not been updated as we have detected errors on you account. Please <2>check and correct them</2> before updating your tag again.": "Lo sentimos, el tag no ha sido actualizado porque hemos encontrado errores en tu cuenta. Por favor <2>revisa y corrígelos</2> antes de actualizar tu tag de nuevo.",
  "Oops, your tag has been updated but we have detected errors on your account. Please <2>check and correct them</2> before updating your tag again.": "Lo sentimos, hemos encontrado errores en tu cuenta. Por favor <2>revisa y corrígelos</2> antes de actualizar tu tag de nuevo.",
  "Option not available": "Opción no disponible",
  "Please update the tag to validate your changes.": "Por favor actualiza el tag para validar los cambios.",
  "Processing compilation": "Compilando",
  "Publishing modifications": "Publicando las modificaciones",
  "Sending request": "Enviando la solicitud",
  "Sending to server": "Enviando al servidor",
  "Sorry, your tag has not been updated as we encountered an error on our side... Please try again later.": "Lo sentimos, el tag no ha sido actualizado porque hemos encontrado un error. Por favor, inténtalo de nuevo más tarde.",
  Tag: bu,
  "Tag version: ": "Versión del tag:",
  "You can't update your tag as your account is currently inactive.": "No puedes actualizar el tag debido a que tu cuenta está inactiva.",
  "Your access level does not allow you to perform this action, contact the owner of the account to increase your level of access.": "Oh no, los derechos de tu usuario actual no te permiten realizar esta acción. Por favor contacta con el administrador de la cuenta.",
  "Your tag has been successfully updated": "El tag ha sido actualizado con éxito",
  "Your tag has been successfully updated on the {{- lastUpdate}}": "El tag ha sido actualizado con éxito el {{- lastUpdate}}"
}, xu = "閉じる", Tu = "タグ", Su = {
  "All the modifications you have made before this time are currently live on your website.": "これまでに加えた変更はすべて、現在 Web サイトに反映されています。",
  close: xu,
  "It looks like your AB Tasty library is empty. This means that your campaigns are temporarily deactivated.\n  To continue running you campaigns, click Recreate library directly from the dashboard or Rebuild framework in the Settings.": `AB Tasty ライブラリが空のようです。これは、キャンペーンが一時的に無効化されていることを意味します。
 キャンペーンの実行を続行するには、ダッシュボードから直接「ライブラリを再作成」をクリックするか、設定で「フレームワークを再構築」をクリックします。`,
  "Last successful update: {{- lastUpdate}}. All the modifications you have made after this time are not live on your website.": "最後に成功した更新: {{- lastUpdate}}。この時点以降に行った変更はすべて、Web サイトに反映されません。",
  "Last update : ": "最後の更新：",
  "Last update has been forced. The identified error(s) are still present on your account. Please <2>check and correct them</2> before updating your tag again.": "最終更新が強制されました。特定されたエラーはアカウントにまだ存在します。タグを再度更新する前に、<2>確認して修正</2>してください。",
  "Once you update the tag, all changes made to your active campaigns and/or account settings since the last update will be visible in production.": "タグを更新すると、最後の更新以降にアクティブなキャンペーンやアカウント設定に加えられたすべての変更が本番環境に表示されます。",
  "Oops, you tag has not been updated as we have detected errors on you account. Please <2>check and correct them</2> before updating your tag again.": "アカウントにエラーが検出されたため、タグは更新されていません。タグを再度更新する前に、<2>確認して修正</2>してください。",
  "Oops, your tag has been updated but we have detected errors on your account. Please <2>check and correct them</2> before updating your tag again.": "タグは更新されましたが、アカウントにエラーが検出されました。タグを再度更新する前に、<2>確認して修正</2>してください。",
  "Option not available": "オプションは利用できません",
  "Please update the tag to validate your changes.": "変更を検証するにはタグを更新してください。",
  "Processing compilation": "処理コンパイル",
  "Publishing modifications": "変更の公開",
  "Sending request": "リクエストの送信",
  "Sending to server": "サーバーに送信中",
  "Sorry, your tag has not been updated as we encountered an error on our side... Please try again later.": "申し訳ありませんが、側でエラーが発生したため、タグは更新されていません...しばらくしてからもう一度お試しください。",
  Tag: Tu,
  "Tag version: ": "タグのバージョン:",
  "You can't update your tag as your account is currently inactive.": "アカウントは現在非アクティブであるため、タグを更新できません。",
  "Your access level does not allow you to perform this action, contact the owner of the account to increase your level of access.": "アクセス レベルではこのアクションを実行できません。アカウントの所有者に問い合わせて、アクセス レベルを上げてください。",
  "Your tag has been successfully updated": "タグは正常に更新されました",
  "Your tag has been successfully updated on the {{- lastUpdate}}": "タグは {{- lastUpdate}} で正常に更新されました"
}, Eu = "Schließen", Ou = "Tag", Cu = {
  "All the modifications you have made before this time are currently live on your website.": "All the modifications you have made before this time are currently live on your website.",
  close: Eu,
  "It looks like your AB Tasty library is empty. This means that your campaigns are temporarily deactivated.\n  To continue running you campaigns, click Recreate library directly from the dashboard or Rebuild framework in the Settings.": `Es scheint, dass das AB Tasty-Skript leer ist. Dies bedeutet, dass Ihre Kampagnen vorübergehend deaktiviert sind.
Um Ihre Kampagnen weiterzuführen, klicken Sie auf Skript neu erstellen direkt in der Kampagnenliste oder in den Einstellungen.`,
  "Last successful update: {{- lastUpdate}}. All the modifications you have made after this time are not live on your website.": "Letztes erfolgreiches Update: {{- lastUpdate}}. Alle vorher vorgenommenen Änderungen sind auf Ihrer Seite nicht live.",
  "Last update : ": "Letzte Aktualisierung:",
  "Last update has been forced. The identified error(s) are still present on your account. Please <2>check and correct them</2> before updating your tag again.": "Wir haben einen oder mehrere Fehler in Ihrem Konto festgestellt. Bitte <2>überprüfen und korrigieren</2> Sie diese, bevor Sie Ihr Tag erneut aktualisieren.",
  "Once you update the tag, all changes made to your active campaigns and/or account settings since the last update will be visible in production.": "Sobald Sie das Tag updaten werden alle Änderungen live in Produktion genomnmen, die seit dem letzten Update an aktiven Kampagnen und/oder den Account Einstellungen vorgenommen wurden.",
  "Oops, you tag has not been updated as we have detected errors on you account. Please <2>check and correct them</2> before updating your tag again.": "Ups, Ihr Tag wurde nicht aktualisiert, da wir Fehler in Ihrem Account identifizieren konnten. Bitte <2>überprüfen und korrigieren Sie diese</2> bevor Sie das Tag nochmal aktualisieren.",
  "Oops, your tag has been updated but we have detected errors on your account. Please <2>check and correct them</2> before updating your tag again.": "Hoppla, wir haben Fehler in Ihrem Konto festgestellt. Bitte <2>überprüfen und korrigieren Sie dies</2>, bevor Sie das Tag erneut aktualisieren.",
  "Option not available": "Option nicht verfügbar",
  "Please update the tag to validate your changes.": "Bitte aktualisieren Sie ihren Tag um die Änderungen zu bestätigen.",
  "Processing compilation": "Zusammenstellung",
  "Publishing modifications": "Veröffentlicht Veränderungen",
  "Sending request": "Sendet Anfrage",
  "Sending to server": "Sendet an den Server",
  "Sorry, your tag has not been updated as we encountered an error on our side... Please try again later.": "Ups, Ihr Tag wurde nicht aktualisiert, da auf Ihrer Seite ein Fehler aufgetreten ist ... Bitte versuchen Sie es später erneut.",
  Tag: Ou,
  "Tag version: ": "Tag-Version",
  "You can't update your tag as your account is currently inactive.": "Sie können ihr Tag nicht aktualisieren, da ihr Account momentan inaktiv ist.",
  "Your access level does not allow you to perform this action, contact the owner of the account to increase your level of access.": "Oh nein, mit Ihren aktuellen Nutzerrechten können Sie diese Aktion nicht durchführen. Bitte kontaktieren Sie den Administrator Ihres Accounts.",
  "Your tag has been successfully updated": "Ihr Tag wurde erfolgreich aktualisiert",
  "Your tag has been successfully updated on the {{- lastUpdate}}": "Ihr Tag wurde am erfolgreich aktualisiert {{- lastUpdate}}"
}, Pu = {
  en_US: "en"
}, ku = (t = "en") => Pu[t] ?? t;
ge.use(fi).use(ha).init(
  {
    supportedLngs: ["de", "en", "es", "fr", "ja"],
    fallbackLng: {
      en: ["en"],
      "en-GB": ["en"],
      default: ["en"]
    },
    resources: {
      en: { translation: pu },
      fr: { translation: yu },
      es: { translation: wu },
      ja: { translation: Su },
      de: { translation: Cu }
    },
    detection: {
      order: ["querystring", "navigator", "htmlTag"],
      lookupQuerystring: "lang",
      caches: []
    },
    keySeparator: "--",
    nsSeparator: "__",
    pluralSeparator: "_",
    contextSeparator: "::",
    react: {
      transKeepBasicHtmlNodesFor: []
      // Our parser does not handle keeping basic html nodes yet
    },
    interpolation: {
      escapeValue: !1
    }
  },
  (t) => {
    t && console.error("could not init i18n", t);
  }
);
const _u = () => {
  const {
    notification: t,
    compilation: {
      initialized: e,
      progress: n,
      lastDate: r,
      clearing: a,
      status: i,
      fetching: s,
      tagCompilation: o,
      isEmpty: u
    },
    isButtonUsable: c,
    pack: l,
    locale: h,
    language: d,
    timezone: m,
    tagVersion: g,
    hasPrivilege: w,
    settingsUrl: y,
    onEvent: P,
    hideNotification: E,
    showWarningNotification: x,
    showSuccessNotification: T,
    setCompilationProgress: p,
    fetchTagState: S,
    compileTag: A
  } = Do(), { status: R, error: V } = o || {}, { warning: J, succeeded: q, succeeded_info: ee, failedWithErrors: pe, failed: te, failed_info: oe } = pn(), [ie, K] = Te(!1), [re, de] = Te(!!n && n !== fe.done), [v, O] = Te(), [D, j] = Te(re), [_, B] = Te(s), [U, M] = Te(!1);
  we(() => {
    ge.changeLanguage(ku(d));
  }, [d]), we(() => {
    !e && c && S();
  }, [e, c]), we(() => {
    let se = null;
    return !s && _ && (M(!0), se = setTimeout(() => {
      M(!1);
    }, 12e4)), s && !_ && R !== ue.Pending && (t !== null && E(), de(!0), a || j(!0), O(!1)), B(s), () => {
      se && clearTimeout(se), M(!1);
    };
  }, [s]), we(() => {
    R === ue.Pending && de(!1);
  }, [R]);
  const z = () => {
    !u && i !== Oe.empty && (de(!0), a || j(!0), O(!1), w ? (P == null || P("compile-tag-clicked"), A()) : K(!0));
  }, W = La(() => {
    if (r)
      return an({
        date: r,
        locale: h,
        timezone: m
      });
  }, [r, h, m]), Y = es({
    clearing: a,
    compilationStatus: R,
    compilationError: V,
    pack: l,
    showCheckMark: U,
    status: i,
    fetching: s
  });
  we(() => {
    let se = null;
    return D && n === fe.publishment && (se = setTimeout(() => {
      O(!0), j(!1), Y === $.warning ? x({ label: J(y) }) : T({
        label: q(W),
        description: W ? ee : void 0
      });
    }, 3250)), () => {
      se && clearTimeout(se);
    };
  }, [n, W]), we(() => {
    let se = null;
    return D && R && [ue.Error, ue.Timeout].includes(R) && (se = setTimeout(() => {
      O(!0), j(!1), St(V) ? Y === $.warning ? x({ label: J(y) }) : sn({ label: pe(y) }) : sn({
        label: te,
        description: W ? oe(W) : void 0
      });
    }, 3e3)), () => {
      se && clearTimeout(se);
    };
  }, [[V, R, W]]), we(() => {
    v && p(fe.done);
  }, [v]);
  const he = t && (t.type === ve.success || n === fe.done) ? {
    ...t,
    hideNotification: E
  } : void 0, C = D ? {
    step: n ?? fe.request,
    error: !re && R && [ue.Error, ue.Timeout].includes(R)
  } : void 0;
  return /* @__PURE__ */ N.jsxs(N.Fragment, { children: [
    /* @__PURE__ */ N.jsx(bi, { modalIsOpen: ie, toggleModal: K }),
    c && /* @__PURE__ */ N.jsx(
      Zi,
      {
        onClick: z,
        status: Y,
        version: g,
        lastUpdate: W,
        frameworkSettingsUrl: y,
        notification: he,
        progress: C
      }
    )
  ] });
};
export {
  Du as TagContextProvider,
  _u as TagRefreshButton,
  Oe as TagUpdateStatus,
  Do as useTagContext
};
//# sourceMappingURL=index.js.map
